import { action, observable } from "mobx"
import shop from "shop/shop"

class ReportStoreStore {

  @observable searchTerm = ""

  @observable list = []
  @observable byId = new Map()
  @observable deliveryAddress = false
  @observable invoiceAddress = false
  @observable baseAddress = false

  @action
  async postBaseReport( template, data ) {
    console.log('do base report',template,data);
    return fetch( `/shop/rest/reports/create?template=${template}`,
      {
        method : "POST",
        headers: {
          'content-type': 'application/json'
        },
        body   : JSON.stringify( data )
      } )
      .then( async res => {
        console.log( "res", res )
        if ( res.status === 200 ) {
          return res.json()
        }
        const error = await res.text()
        return { error }

      } )
      .catch( error => {
        return { error: true }
      } )
  }

  @action
  async postReport( template, products ) {
    const mainarticles = products.map( p => p.mainart )
// TODO: => SORT BY article_nr
    //[{"field":"mainArticle","op":"in","value":["APB01321000"]}]
    //[{"field":"mainArticle","op":"in","value":["EN98593MHD","EN98334MHD","EN98334MHD","EN98772MHD","EN98611MHD","EN98593MHD"]}]
    //[{"field":"mainArticle","op":"in","value":["EN98593MHD","EN98334MHD","EN98334MHD","EN98772MHD","EN98611MHD","EN98593MHD"]}
    const filter = encodeURIComponent( `[{"field":"mainArticle","op":"in","value":${JSON.stringify( mainarticles )}}]` )
    const data = await fetch( `/shop/rest/data/search?start=0&count=64&sort=article_nr&dir=asc&lang=de&filter=${filter}` )
      .then( res => res.json() )

    data.cart = await shop.cart.get()

    return fetch( `/shop/rest/reports/create?template=${template}`,
      {
        method : "POST",
        headers: {
          'content-type': 'application/json'
        },
        body   : JSON.stringify( data )
      } )
      .then( async res => {
        console.log( "res", res )
        if ( res.status === 200 ) {
          return res.json()
        }
        const error = await res.text()
        return { error }

      } )
      .catch( error => {
        return { error: true }
      } )
  }
}

const testJSON = {
  "result": [
    {
      "mainart"     : "APB01321000",
      "reordered"   : true,
      "map_pic_id"  : "A-PB01321-000",
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Ameo Powerbreather",
        "winline_art" : "A-PB01321-000",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "A-PB01321-000",
        "vororder"    : "false",
        "uvp"         : "24.95",
        "groesse"     : "null",
        "sale"        : "false",
        "cat_id"      : "00047-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "5.0",
        "Variante"    : "Medium Short, blue"
      },
      "type"        : 1,
      "pinfos"      : {
        "brutto": "12"
      },
      "map_id"      : "APB01321000",
      "price"       : 12.0,
      "map_desc_id" : "APB01321000",
      "stock"       : 5.0,
      "barcode"     : "4260416993020",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "vat"         : 19,
      "sort"        : "00005",
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "APB01321000",
          "cat_id"    : "00047-00002-00000-00000-00000",
          "sort"      : "APB01321000"
        }
      ],
      "parts"       : {
        "variants": [
          "Variante",
          "groesse"
        ],
        "articles": [
          "APB01321000",
          "APB01322000",
          "APB01323000",
          "APB01326000",
          "APB01326P00"
        ],
        "info"    : {
          "APB01323000": {
            "image"     : "A-PB01323-000",
            "groesse"   : "null",
            "quantities": [
              {
                "id"   : "Stk",
                "multi": "1,00"
              }
            ],
            "stock"     : 5.0,
            "Variante"  : "Power Short, blue"
          },
          "APB01321000": {
            "image"     : "A-PB01321-000",
            "groesse"   : "null",
            "quantities": [
              {
                "id"   : "Stk",
                "multi": "1,00"
              }
            ],
            "stock"     : 5.0,
            "Variante"  : "Medium Short, blue"
          },
          "APB01322000": {
            "image"     : "A-PB01322-000",
            "groesse"   : "null",
            "quantities": [
              {
                "id"   : "Stk",
                "multi": "1,00"
              }
            ],
            "stock"     : 6.0,
            "Variante"  : "Easy Short, blue"
          },
          "APB01326000": {
            "image"     : "A-PB01326-000",
            "groesse"   : "null",
            "quantities": [
              {
                "id"   : "Stk",
                "multi": "1,00"
              }
            ],
            "stock"     : 5.0,
            "Variante"  : "Easy Long, blue"
          },
          "APB01326P00": {
            "image"     : "A-PB01326-000",
            "groesse"   : "null",
            "quantities": [
              {
                "id"   : "Stk",
                "multi": "1,00"
              }
            ],
            "stock"     : 5.0,
            "Variante"  : "Easy Long, blue"
          }
        }
      },
      "article_nr"  : "A-PB01321-000",
      "hash"        : "8f8b3026594c771e5fda20041a1b0bcf",
      "map_price_id": "APB01321000",
      "desc"        : {
        "search"   : "Ameo Powerbreather",
        "des"      : "Ameo Powerbreather Accessories Speed Vent Medium S",
        "map_id"   : "A-PB01321-000de",
        "remapid"  : "APB01321000",
        "extras"   : {},
        "label"    : "A-PB01321-000",
        "lang"     : "de",
        "short_des": "Ameo Powerbreather Accessories Speed Vent Medium S",
        "type"     : 0,
        "hash"     : "ba3248d84f604bc8efc20bccb80d666d"
      }
    },
    {
      "mainart"     : "APB01321000",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "A-PB01322-000",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Ameo Powerbreather",
        "winline_art" : "A-PB01322-000",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "A-PB01322-000",
        "vororder"    : "false",
        "uvp"         : "24.95",
        "groesse"     : "null",
        "sale"        : "false",
        "cat_id"      : "00047-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "6.0",
        "Variante"    : "Easy Short, blue"
      },
      "sort"        : "00006",
      "type"        : 1,
      "pinfos"      : {
        "brutto": "12"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "APB01322000",
          "cat_id"    : "00047-00002-00000-00000-00000",
          "sort"      : "APB01322000"
        }
      ],
      "map_id"      : "APB01322000",
      "price"       : 12.0,
      "map_desc_id" : "APB01322000",
      "article_nr"  : "A-PB01322-000",
      "stock"       : 6.0,
      "barcode"     : "4260416993112",
      "hash"        : "33c2ee5ee3d21fde39ad7f1d1ef39338",
      "map_price_id": "APB01322000",
      "desc"        : {
        "search"   : "Ameo Powerbreather",
        "des"      : "Ameo Powerbreather Accessories Speed Vent Easy S",
        "map_id"   : "A-PB01322-000de",
        "remapid"  : "APB01322000",
        "extras"   : {},
        "label"    : "A-PB01322-000",
        "lang"     : "de",
        "short_des": "Ameo Powerbreather Accessories Speed Vent Easy S",
        "type"     : 0,
        "hash"     : "6b4495e133368506c3c78f73d842dc48"
      }
    },
    {
      "mainart"     : "APB01321000",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "A-PB01323-000",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Ameo Powerbreather",
        "winline_art" : "A-PB01323-000",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "A-PB01323-000",
        "vororder"    : "false",
        "uvp"         : "24.95",
        "groesse"     : "null",
        "sale"        : "false",
        "cat_id"      : "00047-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "5.0",
        "Variante"    : "Power Short, blue"
      },
      "sort"        : "00005",
      "type"        : 1,
      "pinfos"      : {
        "brutto": "12"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "APB01323000",
          "cat_id"    : "00047-00002-00000-00000-00000",
          "sort"      : "APB01323000"
        }
      ],
      "map_id"      : "APB01323000",
      "price"       : 12.0,
      "map_desc_id" : "APB01323000",
      "article_nr"  : "A-PB01323-000",
      "stock"       : 5.0,
      "barcode"     : "4260416993211",
      "hash"        : "578be1eca9b8eb6bd7b35dfd0945d215",
      "map_price_id": "APB01323000",
      "desc"        : {
        "search"   : "Ameo Powerbreather",
        "des"      : "Ameo Powerbreather Accessories Speed Vent Power S",
        "map_id"   : "A-PB01323-000de",
        "remapid"  : "APB01323000",
        "extras"   : {},
        "label"    : "A-PB01323-000",
        "lang"     : "de",
        "short_des": "Ameo Powerbreather Accessories Speed Vent Power S",
        "type"     : 0,
        "hash"     : "927750f6eda94c5df344f603d64b35b4"
      }
    },
    {
      "mainart"     : "APB01321000",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "A-PB01326-000",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Ameo Powerbreather",
        "winline_art" : "A-PB01326-000",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "A-PB01326-000",
        "vororder"    : "false",
        "uvp"         : "29.95",
        "groesse"     : "null",
        "sale"        : "false",
        "cat_id"      : "00047-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "10.0",
        "Variante"    : "Easy Long, blue"
      },
      "sort"        : "00010",
      "type"        : 1,
      "pinfos"      : {
        "brutto": "14.5"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "APB01326000",
          "cat_id"    : "00047-00002-00000-00000-00000",
          "sort"      : "APB01326000"
        }
      ],
      "map_id"      : "APB01326000",
      "price"       : 14.5,
      "map_desc_id" : "APB01326000",
      "article_nr"  : "A-PB01326-000",
      "stock"       : 5.0,
      "barcode"     : "4260416993129",
      "hash"        : "8d721219fee2485da13aa38f1de98d33",
      "map_price_id": "APB01326000",
      "desc"        : {
        "search"   : "Ameo Powerbreather",
        "des"      : "Ameo Powerbreather Accessories Speed Vent Easy L",
        "map_id"   : "A-PB01326-000de",
        "remapid"  : "APB01326000",
        "extras"   : {},
        "label"    : "A-PB01326-000",
        "lang"     : "de",
        "short_des": "Ameo Powerbreather Accessories Speed Vent Easy L",
        "type"     : 0,
        "hash"     : "c240325bfd0ab840a26d260b74d54832"
      }
    },
    {
      "mainart"     : "APB01321000",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "A-PB01326-000",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Ameo Powerbreather",
        "winline_art" : "A-PB01326-P00",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "A-PB01326-000",
        "vororder"    : "false",
        "uvp"         : "29.95",
        "groesse"     : "null",
        "sale"        : "false",
        "cat_id"      : "00047-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "10.0",
        "Variante"    : "Easy Long, blue"
      },
      "sort"        : "00010",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "14.5"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "APB01326P00",
          "cat_id"    : "00047-00002-00000-00000-00000",
          "sort"      : "APB01326P00"
        }
      ],
      "map_id"      : "APB01326P00",
      "price"       : 14.5,
      "map_desc_id" : "APB01326P00",
      "article_nr"  : "A-PB01326-P00",
      "stock"       : 5.0,
      "barcode"     : "4260416993259",
      "hash"        : "6f666432088231da7e45ece81989f6da",
      "map_price_id": "APB01326P00",
      "desc"        : {
        "search"   : "Ameo Powerbreather",
        "des"      : "Ameo Powerbreather Accessories Speed Vent Easy L pink",
        "map_id"   : "A-PB01326-P00de",
        "remapid"  : "APB01326P00",
        "extras"   : {},
        "label"    : "A-PB01326-P00",
        "lang"     : "de",
        "short_des": "Ameo Powerbreather Accessories Speed Vent Easy L",
        "type"     : 0,
        "hash"     : "7a131265efc61d88d35ec1ee3286fe4b"
      }
    },
    {
      "mainart"     : "ES882OT61DN34",
      "reordered"   : true,
      "map_pic_id"  : "ES882OT61DN",
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES882OT61DN-34",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES882OT61DN",
        "vororder"    : "false",
        "uvp"         : "399.95",
        "groesse"     : "34",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "10.0",
        "Variante"    : "dark navy"
      },
      "type"        : 1,
      "pinfos"      : {
        "brutto": "190.45"
      },
      "map_id"      : "ES882OT61DN34",
      "price"       : 190.45,
      "map_desc_id" : "ES882OT61DN34",
      "stock"       : 0.0,
      "barcode"     : "4547469095117",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "vat"         : 19,
      "sort"        : "00254",
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES882OT61DN34",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES882OT61DN34"
        }
      ],
      "parts"       : {
        "variants": [
          "Variante",
          "groesse"
        ],
        "articles": [
          "ES882OT61DN34",
          "ES882OT61DN36",
          "ES882OT61DN38",
          "ES882OT61DN40",
          "ES882OT61DN42",
          "ES882OT61DN44",
          "ES882OT61GN34",
          "ES882OT61GN36",
          "ES882OT61GN38",
          "ES882OT61GN40",
          "ES882OT61GN42",
          "ES882OT61GN44",
          "ES882OT61MA34",
          "ES882OT61MA36",
          "ES882OT61MA38",
          "ES882OT61MA40",
          "ES882OT61MA42",
          "ES882OT61MA44"
        ],
        "info"    : {
          "ES882OT61GN40": {
            "image"     : "ES882OT61GN",
            "groesse"   : "40",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 1.0,
            "Variante"  : "green"
          },
          "ES882OT61GN42": {
            "image"     : "ES882OT61GN",
            "groesse"   : "42",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "green"
          },
          "ES882OT61GN44": {
            "image"     : "ES882OT61GN",
            "groesse"   : "44",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "green"
          },
          "ES882OT61DN38": {
            "image"     : "ES882OT61DN",
            "groesse"   : "38",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 1.0,
            "Variante"  : "dark navy"
          },
          "ES882OT61GN34": {
            "image"     : "ES882OT61GN",
            "groesse"   : "34",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "green"
          },
          "ES882OT61DN36": {
            "image"     : "ES882OT61DN",
            "groesse"   : "36",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "dark navy"
          },
          "ES882OT61GN36": {
            "image"     : "ES882OT61GN",
            "groesse"   : "36",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "green"
          },
          "ES882OT61DN34": {
            "image"     : "ES882OT61DN",
            "groesse"   : "34",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "dark navy"
          },
          "ES882OT61GN38": {
            "image"     : "ES882OT61GN",
            "groesse"   : "38",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "green"
          },
          "ES882OT61DN44": {
            "image"     : "ES882OT61DN",
            "groesse"   : "44",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "dark navy"
          },
          "ES882OT61DN42": {
            "image"     : "ES882OT61DN",
            "groesse"   : "42",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "dark navy"
          },
          "ES882OT61DN40": {
            "image"     : "ES882OT61DN",
            "groesse"   : "40",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "dark navy"
          },
          "ES882OT61MA42": {
            "image"     : "ES882OT61MA",
            "groesse"   : "42",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 1.0,
            "Variante"  : "magenta"
          },
          "ES882OT61MA40": {
            "image"     : "ES882OT61MA",
            "groesse"   : "40",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 2.0,
            "Variante"  : "magenta"
          },
          "ES882OT61MA36": {
            "image"     : "ES882OT61MA",
            "groesse"   : "36",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 1.0,
            "Variante"  : "magenta"
          },
          "ES882OT61MA34": {
            "image"     : "ES882OT61MA",
            "groesse"   : "34",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "magenta"
          },
          "ES882OT61MA44": {
            "image"     : "ES882OT61MA",
            "groesse"   : "44",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "magenta"
          },
          "ES882OT61MA38": {
            "image"     : "ES882OT61MA",
            "groesse"   : "38",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 1.0,
            "Variante"  : "magenta"
          }
        }
      },
      "article_nr"  : "ES882OT61DN-34",
      "hash"        : "89f5718341ddd331b165a9b63f2c0802",
      "map_price_id": "ES882OT61DN34",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Maiko Jacket, dark navy, 34",
        "map_id"   : "ES882OT61DN-34de",
        "remapid"  : "ES882OT61DN34",
        "extras"   : {},
        "label"    : "ES882OT61DN-34",
        "lang"     : "de",
        "short_des": "Maiko Jacket, dark navy",
        "type"     : 0,
        "hash"     : "868ed704cbb3dfeb8ac758b8a9ab7393"
      }
    },
    {
      "mainart"     : "ES882OT61DN34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES882OT61DN",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES882OT61DN-36",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES882OT61DN",
        "vororder"    : "false",
        "uvp"         : "399.95",
        "groesse"     : "36",
        "sale"        : "true",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "-30",
        "varbestand"  : "10.0",
        "Variante"    : "dark navy"
      },
      "sort"        : "00254",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "190.45",
        "rabatt": "-30"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES882OT61DN36",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES882OT61DN36"
        }
      ],
      "map_id"      : "ES882OT61DN36",
      "price"       : 133.315,
      "map_desc_id" : "ES882OT61DN36",
      "article_nr"  : "ES882OT61DN-36",
      "stock"       : 0.0,
      "barcode"     : "4547469095124",
      "hash"        : "50d308d23c54ead9aa61b627cf73fa8c",
      "map_price_id": "ES882OT61DN36",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Maiko Jacket, dark navy, 36",
        "map_id"   : "ES882OT61DN-36de",
        "remapid"  : "ES882OT61DN36",
        "extras"   : {},
        "label"    : "ES882OT61DN-36",
        "lang"     : "de",
        "short_des": "Maiko Jacket, dark navy",
        "type"     : 0,
        "hash"     : "82112fb081590885150d65be43b73a35"
      }
    },
    {
      "mainart"     : "ES882OT61DN34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES882OT61DN",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES882OT61DN-38",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES882OT61DN",
        "vororder"    : "false",
        "uvp"         : "399.95",
        "groesse"     : "38",
        "sale"        : "true",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "-30",
        "varbestand"  : "10.0",
        "Variante"    : "dark navy"
      },
      "sort"        : "00254",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "190.45",
        "rabatt": "-30"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES882OT61DN38",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES882OT61DN38"
        }
      ],
      "map_id"      : "ES882OT61DN38",
      "price"       : 133.315,
      "map_desc_id" : "ES882OT61DN38",
      "article_nr"  : "ES882OT61DN-38",
      "stock"       : 4.0,
      "barcode"     : "4547469095131",
      "hash"        : "de7d01647446812d9f77fd9a9b876aed",
      "map_price_id": "ES882OT61DN38",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Maiko Jacket, dark navy, 38",
        "map_id"   : "ES882OT61DN-38de",
        "remapid"  : "ES882OT61DN38",
        "extras"   : {},
        "label"    : "ES882OT61DN-38",
        "lang"     : "de",
        "short_des": "Maiko Jacket, dark navy",
        "type"     : 0,
        "hash"     : "c6fc5f8ca19ca717b703969cfaae710d"
      }
    },
    {
      "mainart"     : "ES882OT61DN34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES882OT61DN",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES882OT61DN-40",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES882OT61DN",
        "vororder"    : "false",
        "uvp"         : "399.95",
        "groesse"     : "40",
        "sale"        : "true",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "-30",
        "varbestand"  : "10.0",
        "Variante"    : "dark navy"
      },
      "sort"        : "00254",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "190.45",
        "rabatt": "-30"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES882OT61DN40",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES882OT61DN40"
        }
      ],
      "map_id"      : "ES882OT61DN40",
      "price"       : 133.315,
      "map_desc_id" : "ES882OT61DN40",
      "article_nr"  : "ES882OT61DN-40",
      "stock"       : 3.0,
      "barcode"     : "4547469095087",
      "hash"        : "9bb8c129bda3a46aed6644cfe15dbe98",
      "map_price_id": "ES882OT61DN40",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Maiko Jacket, dark navy, 40",
        "map_id"   : "ES882OT61DN-40de",
        "remapid"  : "ES882OT61DN40",
        "extras"   : {},
        "label"    : "ES882OT61DN-40",
        "lang"     : "de",
        "short_des": "Maiko Jacket, dark navy",
        "type"     : 0,
        "hash"     : "6aad4369cc5e62d802ddac9c6d84ffe1"
      }
    },
    {
      "mainart"     : "ES882OT61DN34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES882OT61DN",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES882OT61DN-42",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES882OT61DN",
        "vororder"    : "false",
        "uvp"         : "399.95",
        "groesse"     : "42",
        "sale"        : "true",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "-30",
        "varbestand"  : "10.0",
        "Variante"    : "dark navy"
      },
      "sort"        : "00254",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "190.45",
        "rabatt": "-30"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES882OT61DN42",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES882OT61DN42"
        }
      ],
      "map_id"      : "ES882OT61DN42",
      "price"       : 133.315,
      "map_desc_id" : "ES882OT61DN42",
      "article_nr"  : "ES882OT61DN-42",
      "stock"       : 2.0,
      "barcode"     : "4547469095094",
      "hash"        : "acd08e8d3d9fda1fbc4beff870ddd2a7",
      "map_price_id": "ES882OT61DN42",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Maiko Jacket, dark navy, 42",
        "map_id"   : "ES882OT61DN-42de",
        "remapid"  : "ES882OT61DN42",
        "extras"   : {},
        "label"    : "ES882OT61DN-42",
        "lang"     : "de",
        "short_des": "Maiko Jacket, dark navy",
        "type"     : 0,
        "hash"     : "8f0b2d72878e6707416b675249df4ab2"
      }
    },
    {
      "mainart"     : "ES882OT61DN34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES882OT61DN",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES882OT61DN-44",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES882OT61DN",
        "vororder"    : "false",
        "uvp"         : "399.95",
        "groesse"     : "44",
        "sale"        : "true",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "-30",
        "varbestand"  : "10.0",
        "Variante"    : "dark navy"
      },
      "sort"        : "00254",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "190.45",
        "rabatt": "-30"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES882OT61DN44",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES882OT61DN44"
        }
      ],
      "map_id"      : "ES882OT61DN44",
      "price"       : 133.315,
      "map_desc_id" : "ES882OT61DN44",
      "article_nr"  : "ES882OT61DN-44",
      "stock"       : 1.0,
      "barcode"     : "4547469095100",
      "hash"        : "e3e04da78b9a9c6039f623233d915f01",
      "map_price_id": "ES882OT61DN44",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Maiko Jacket, dark navy, 44",
        "map_id"   : "ES882OT61DN-44de",
        "remapid"  : "ES882OT61DN44",
        "extras"   : {},
        "label"    : "ES882OT61DN-44",
        "lang"     : "de",
        "short_des": "Maiko Jacket, dark navy",
        "type"     : 0,
        "hash"     : "04b0ef8df6882ee8e76ce037b1c1524c"
      }
    },
    {
      "mainart"     : "ES882OT61DN34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES882OT61GN",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES882OT61GN-34",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES882OT61GN",
        "vororder"    : "false",
        "uvp"         : "399.95",
        "groesse"     : "34",
        "sale"        : "true",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "-30",
        "varbestand"  : "34.0",
        "Variante"    : "green"
      },
      "sort"        : "00459",
      "type"        : 1,
      "pinfos"      : {
        "brutto": "190.45",
        "rabatt": "-30"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES882OT61GN34",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES882OT61GN34"
        }
      ],
      "map_id"      : "ES882OT61GN34",
      "price"       : 133.315,
      "map_desc_id" : "ES882OT61GN34",
      "article_nr"  : "ES882OT61GN-34",
      "stock"       : 4.0,
      "barcode"     : "4547469095056",
      "hash"        : "89898e5561ac33910829df8e9fa3635c",
      "map_price_id": "ES882OT61GN34",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Maiko Jacket, green, 34",
        "map_id"   : "ES882OT61GN-34de",
        "remapid"  : "ES882OT61GN34",
        "extras"   : {},
        "label"    : "ES882OT61GN-34",
        "lang"     : "de",
        "short_des": "Maiko Jacket, green",
        "type"     : 0,
        "hash"     : "fcbddc472dabf5876e2247d97c05162d"
      }
    },
    {
      "mainart"     : "ES882OT61DN34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES882OT61GN",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES882OT61GN-36",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES882OT61GN",
        "vororder"    : "false",
        "uvp"         : "399.95",
        "groesse"     : "36",
        "sale"        : "true",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "-30",
        "varbestand"  : "34.0",
        "Variante"    : "green"
      },
      "sort"        : "00459",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "190.45",
        "rabatt": "-30"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES882OT61GN36",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES882OT61GN36"
        }
      ],
      "map_id"      : "ES882OT61GN36",
      "price"       : 133.315,
      "map_desc_id" : "ES882OT61GN36",
      "article_nr"  : "ES882OT61GN-36",
      "stock"       : 5.0,
      "barcode"     : "4547469095063",
      "hash"        : "efb7757c17c72d11396d603fb3ee73e7",
      "map_price_id": "ES882OT61GN36",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Maiko Jacket, green, 36",
        "map_id"   : "ES882OT61GN-36de",
        "remapid"  : "ES882OT61GN36",
        "extras"   : {},
        "label"    : "ES882OT61GN-36",
        "lang"     : "de",
        "short_des": "Maiko Jacket, green",
        "type"     : 0,
        "hash"     : "9a75dd3a528d551b88b4bf80d1adfffc"
      }
    },
    {
      "mainart"     : "ES882OT61DN34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES882OT61GN",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES882OT61GN-38",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES882OT61GN",
        "vororder"    : "false",
        "uvp"         : "399.95",
        "groesse"     : "38",
        "sale"        : "true",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "-30",
        "varbestand"  : "34.0",
        "Variante"    : "green"
      },
      "sort"        : "00459",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "190.45",
        "rabatt": "-30"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES882OT61GN38",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES882OT61GN38"
        }
      ],
      "map_id"      : "ES882OT61GN38",
      "price"       : 133.315,
      "map_desc_id" : "ES882OT61GN38",
      "article_nr"  : "ES882OT61GN-38",
      "stock"       : 7.0,
      "barcode"     : "4547469095070",
      "hash"        : "c5f191b1bbf9d899077cad0aa19b67d6",
      "map_price_id": "ES882OT61GN38",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Maiko Jacket, green, 38",
        "map_id"   : "ES882OT61GN-38de",
        "remapid"  : "ES882OT61GN38",
        "extras"   : {},
        "label"    : "ES882OT61GN-38",
        "lang"     : "de",
        "short_des": "Maiko Jacket, green",
        "type"     : 0,
        "hash"     : "70e199410bcd960f96934c165474b037"
      }
    },
    {
      "mainart"     : "ES882OT61DN34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES882OT61GN",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES882OT61GN-40",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES882OT61GN",
        "vororder"    : "false",
        "uvp"         : "399.95",
        "groesse"     : "40",
        "sale"        : "true",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "-30",
        "varbestand"  : "34.0",
        "Variante"    : "green"
      },
      "sort"        : "00459",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "190.45",
        "rabatt": "-30"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES882OT61GN40",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES882OT61GN40"
        }
      ],
      "map_id"      : "ES882OT61GN40",
      "price"       : 133.315,
      "map_desc_id" : "ES882OT61GN40",
      "article_nr"  : "ES882OT61GN-40",
      "stock"       : 13.0,
      "barcode"     : "4547469095025",
      "hash"        : "c7ec75fd6500ab2b8e8e28bf6a0d5939",
      "map_price_id": "ES882OT61GN40",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Maiko Jacket, green, 40",
        "map_id"   : "ES882OT61GN-40de",
        "remapid"  : "ES882OT61GN40",
        "extras"   : {},
        "label"    : "ES882OT61GN-40",
        "lang"     : "de",
        "short_des": "Maiko Jacket, green",
        "type"     : 0,
        "hash"     : "3854554525c1101092492dc1df73d2ed"
      }
    },
    {
      "mainart"     : "ES882OT61DN34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES882OT61GN",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES882OT61GN-42",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES882OT61GN",
        "vororder"    : "false",
        "uvp"         : "399.95",
        "groesse"     : "42",
        "sale"        : "true",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "-30",
        "varbestand"  : "34.0",
        "Variante"    : "green"
      },
      "sort"        : "00459",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "190.45",
        "rabatt": "-30"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES882OT61GN42",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES882OT61GN42"
        }
      ],
      "map_id"      : "ES882OT61GN42",
      "price"       : 133.315,
      "map_desc_id" : "ES882OT61GN42",
      "article_nr"  : "ES882OT61GN-42",
      "stock"       : 5.0,
      "barcode"     : "4547469095032",
      "hash"        : "ba1da5d2f6bb5012c206714d9c0eb832",
      "map_price_id": "ES882OT61GN42",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Maiko Jacket, green, 42",
        "map_id"   : "ES882OT61GN-42de",
        "remapid"  : "ES882OT61GN42",
        "extras"   : {},
        "label"    : "ES882OT61GN-42",
        "lang"     : "de",
        "short_des": "Maiko Jacket, green",
        "type"     : 0,
        "hash"     : "2a3ae444fed3cbef9e4a30ec33962299"
      }
    },
    {
      "mainart"     : "ES882OT61DN34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES882OT61GN",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES882OT61GN-44",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES882OT61GN",
        "vororder"    : "false",
        "uvp"         : "399.95",
        "groesse"     : "44",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "34.0",
        "Variante"    : "green"
      },
      "sort"        : "00459",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "190.45"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES882OT61GN44",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES882OT61GN44"
        }
      ],
      "map_id"      : "ES882OT61GN44",
      "price"       : 190.45,
      "map_desc_id" : "ES882OT61GN44",
      "article_nr"  : "ES882OT61GN-44",
      "stock"       : 0.0,
      "barcode"     : "4547469095049",
      "hash"        : "ba8c3651220d7c6d7e4aeda3477f5385",
      "map_price_id": "ES882OT61GN44",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Maiko Jacket, green, 44",
        "map_id"   : "ES882OT61GN-44de",
        "remapid"  : "ES882OT61GN44",
        "extras"   : {},
        "label"    : "ES882OT61GN-44",
        "lang"     : "de",
        "short_des": "Maiko Jacket, green",
        "type"     : 0,
        "hash"     : "636e37e5e1cd511ac565163ffd58b3e1"
      }
    },
    {
      "mainart"     : "ES882OT61DN34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES882OT61MA",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES882OT61MA-34",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES882OT61MA",
        "vororder"    : "false",
        "uvp"         : "399.95",
        "groesse"     : "34",
        "sale"        : "true",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "-30",
        "varbestand"  : "61.0",
        "Variante"    : "magenta"
      },
      "sort"        : "00766",
      "type"        : 1,
      "pinfos"      : {
        "brutto": "190.45",
        "rabatt": "-30"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES882OT61MA34",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES882OT61MA34"
        }
      ],
      "map_id"      : "ES882OT61MA34",
      "price"       : 133.315,
      "map_desc_id" : "ES882OT61MA34",
      "article_nr"  : "ES882OT61MA-34",
      "stock"       : 0.0,
      "barcode"     : "4547469095230",
      "hash"        : "8e84ca61cb5b3f3d6103c9f3ffb50940",
      "map_price_id": "ES882OT61MA34",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Maiko Jacket, magenta, 34",
        "map_id"   : "ES882OT61MA-34de",
        "remapid"  : "ES882OT61MA34",
        "extras"   : {},
        "label"    : "ES882OT61MA-34",
        "lang"     : "de",
        "short_des": "Maiko Jacket, magenta",
        "type"     : 0,
        "hash"     : "e4093654e1e3669362749988d44f0f81"
      }
    },
    {
      "mainart"     : "ES882OT61DN34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES882OT61MA",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES882OT61MA-36",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES882OT61MA",
        "vororder"    : "false",
        "uvp"         : "399.95",
        "groesse"     : "36",
        "sale"        : "true",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "-30",
        "varbestand"  : "61.0",
        "Variante"    : "magenta"
      },
      "sort"        : "00766",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "190.45",
        "rabatt": "-30"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES882OT61MA36",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES882OT61MA36"
        }
      ],
      "map_id"      : "ES882OT61MA36",
      "price"       : 133.315,
      "map_desc_id" : "ES882OT61MA36",
      "article_nr"  : "ES882OT61MA-36",
      "stock"       : 10.0,
      "barcode"     : "4547469095247",
      "hash"        : "02c6b1efb4cbf1dc2de49d217256ff90",
      "map_price_id": "ES882OT61MA36",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Maiko Jacket, magenta, 36",
        "map_id"   : "ES882OT61MA-36de",
        "remapid"  : "ES882OT61MA36",
        "extras"   : {},
        "label"    : "ES882OT61MA-36",
        "lang"     : "de",
        "short_des": "Maiko Jacket, magenta",
        "type"     : 0,
        "hash"     : "0f33d063a44d0fffd1fc48d48ba2d4e2"
      }
    },
    {
      "mainart"     : "ES882OT61DN34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES882OT61MA",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES882OT61MA-38",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES882OT61MA",
        "vororder"    : "false",
        "uvp"         : "399.95",
        "groesse"     : "38",
        "sale"        : "true",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "-30",
        "varbestand"  : "61.0",
        "Variante"    : "magenta"
      },
      "sort"        : "00766",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "190.45",
        "rabatt": "-30"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES882OT61MA38",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES882OT61MA38"
        }
      ],
      "map_id"      : "ES882OT61MA38",
      "price"       : 133.315,
      "map_desc_id" : "ES882OT61MA38",
      "article_nr"  : "ES882OT61MA-38",
      "stock"       : 17.0,
      "barcode"     : "4547469095254",
      "hash"        : "2ba2ab0d19429f84205d5a454cdada32",
      "map_price_id": "ES882OT61MA38",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Maiko Jacket, magenta, 38",
        "map_id"   : "ES882OT61MA-38de",
        "remapid"  : "ES882OT61MA38",
        "extras"   : {},
        "label"    : "ES882OT61MA-38",
        "lang"     : "de",
        "short_des": "Maiko Jacket, magenta",
        "type"     : 0,
        "hash"     : "4bad5c437b5b29a8ad467cd73b94dc1a"
      }
    },
    {
      "mainart"     : "ES882OT61DN34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES882OT61MA",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES882OT61MA-40",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES882OT61MA",
        "vororder"    : "false",
        "uvp"         : "399.95",
        "groesse"     : "40",
        "sale"        : "true",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "-30",
        "varbestand"  : "61.0",
        "Variante"    : "magenta"
      },
      "sort"        : "00766",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "190.45",
        "rabatt": "-30"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES882OT61MA40",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES882OT61MA40"
        }
      ],
      "map_id"      : "ES882OT61MA40",
      "price"       : 133.315,
      "map_desc_id" : "ES882OT61MA40",
      "article_nr"  : "ES882OT61MA-40",
      "stock"       : 16.0,
      "barcode"     : "4547469095209",
      "hash"        : "0663fa9f38deae21febd8f98a6fa7005",
      "map_price_id": "ES882OT61MA40",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Maiko Jacket, magenta, 40",
        "map_id"   : "ES882OT61MA-40de",
        "remapid"  : "ES882OT61MA40",
        "extras"   : {},
        "label"    : "ES882OT61MA-40",
        "lang"     : "de",
        "short_des": "Maiko Jacket, magenta",
        "type"     : 0,
        "hash"     : "a26ad1933fc9f11f15604dc7dfbbf448"
      }
    },
    {
      "mainart"     : "ES882OT61DN34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES882OT61MA",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES882OT61MA-42",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES882OT61MA",
        "vororder"    : "false",
        "uvp"         : "399.95",
        "groesse"     : "42",
        "sale"        : "true",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "-30",
        "varbestand"  : "61.0",
        "Variante"    : "magenta"
      },
      "sort"        : "00766",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "190.45",
        "rabatt": "-30"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES882OT61MA42",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES882OT61MA42"
        }
      ],
      "map_id"      : "ES882OT61MA42",
      "price"       : 133.315,
      "map_desc_id" : "ES882OT61MA42",
      "article_nr"  : "ES882OT61MA-42",
      "stock"       : 15.0,
      "barcode"     : "4547469095216",
      "hash"        : "f885c5f71ce265e148c90d421a09b1e0",
      "map_price_id": "ES882OT61MA42",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Maiko Jacket, magenta, 42",
        "map_id"   : "ES882OT61MA-42de",
        "remapid"  : "ES882OT61MA42",
        "extras"   : {},
        "label"    : "ES882OT61MA-42",
        "lang"     : "de",
        "short_des": "Maiko Jacket, magenta",
        "type"     : 0,
        "hash"     : "3c70c5069782da7306ee712b85e9bb65"
      }
    },
    {
      "mainart"     : "ES882OT61DN34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES882OT61MA",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES882OT61MA-44",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES882OT61MA",
        "vororder"    : "false",
        "uvp"         : "399.95",
        "groesse"     : "44",
        "sale"        : "true",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "-30",
        "varbestand"  : "61.0",
        "Variante"    : "magenta"
      },
      "sort"        : "00766",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "190.45",
        "rabatt": "-30"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES882OT61MA44",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES882OT61MA44"
        }
      ],
      "map_id"      : "ES882OT61MA44",
      "price"       : 133.315,
      "map_desc_id" : "ES882OT61MA44",
      "article_nr"  : "ES882OT61MA-44",
      "stock"       : 3.0,
      "barcode"     : "4547469095223",
      "hash"        : "a6d33b36fd0d3592afdb76f2410a2d19",
      "map_price_id": "ES882OT61MA44",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Maiko Jacket, magenta, 44",
        "map_id"   : "ES882OT61MA-44de",
        "remapid"  : "ES882OT61MA44",
        "extras"   : {},
        "label"    : "ES882OT61MA-44",
        "lang"     : "de",
        "short_des": "Maiko Jacket, magenta",
        "type"     : 0,
        "hash"     : "3de76a39fa66220ba6603b5fcfed10b1"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61BK",
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61BK-34",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES982OB61BK",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "34",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "50.0",
        "Variante"    : "black"
      },
      "type"        : 1,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "map_id"      : "ES982OB61BK34",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61BK34",
      "stock"       : 0.0,
      "barcode"     : "4547469310722",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "vat"         : 19,
      "sort"        : "00855",
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61BK34",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61BK34"
        }
      ],
      "parts"       : {
        "variants": [
          "Variante",
          "groesse"
        ],
        "articles": [
          "ES982OB61BK34",
          "ES982OB61BK36",
          "ES982OB61BK38",
          "ES982OB61BK40",
          "ES982OB61BK42",
          "ES982OB61BK44",
          "ES982OB61BK46",
          "ES982OB61BK48",
          "ES982OB61BO34",
          "ES982OB61BO36",
          "ES982OB61BO38",
          "ES982OB61BO40",
          "ES982OB61BO42",
          "ES982OB61BO44",
          "ES982OB61BO46",
          "ES982OB61BO48",
          "ES982OB61DN34",
          "ES982OB61DN36",
          "ES982OB61DN38",
          "ES982OB61DN40",
          "ES982OB61DN42",
          "ES982OB61DN44",
          "ES982OB61DN46",
          "ES982OB61DN48",
          "ES982OB61MA34",
          "ES982OB61MA36",
          "ES982OB61MA38",
          "ES982OB61MA40",
          "ES982OB61MA42",
          "ES982OB61MA44",
          "ES982OB61MA46",
          "ES982OB61MA48",
          "ES982OB61WT34",
          "ES982OB61WT36",
          "ES982OB61WT38",
          "ES982OB61WT40",
          "ES982OB61WT42",
          "ES982OB61WT44",
          "ES982OB61WT46",
          "ES982OB61WT48"
        ],
        "info"    : {
          "ES982OB61DN42": {},
          "ES982OB61BK42": {
            "image"     : "ES982OB61BK",
            "groesse"   : "42",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "black"
          },
          "ES982OB61WT38": {
            "image"     : "ES982OB61WT",
            "groesse"   : "38",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 17.0,
            "Variante"  : "white"
          },
          "ES982OB61DN40": {},
          "ES982OB61BK40": {
            "image"     : "ES982OB61BK",
            "groesse"   : "40",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 19.0,
            "Variante"  : "black"
          },
          "ES982OB61DN46": {},
          "ES982OB61BK46": {
            "image"     : "ES982OB61BK",
            "groesse"   : "46",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "black"
          },
          "ES982OB61BO42": {
            "image"     : "ES982OB61BO",
            "groesse"   : "42",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 2.0,
            "Variante"  : "bordeaux"
          },
          "ES982OB61WT34": {
            "image"     : "ES982OB61WT",
            "groesse"   : "34",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "white"
          },
          "ES982OB61DN44": {},
          "ES982OB61BK44": {
            "image"     : "ES982OB61BK",
            "groesse"   : "44",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "black"
          },
          "ES982OB61BO40": {
            "image"     : "ES982OB61BO",
            "groesse"   : "40",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 2.0,
            "Variante"  : "bordeaux"
          },
          "ES982OB61WT36": {
            "image"     : "ES982OB61WT",
            "groesse"   : "36",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 3.0,
            "Variante"  : "white"
          },
          "ES982OB61BO36": {
            "image"     : "ES982OB61BO",
            "groesse"   : "36",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 5.0,
            "Variante"  : "bordeaux"
          },
          "ES982OB61DN38": {},
          "ES982OB61BK38": {
            "image"     : "ES982OB61BK",
            "groesse"   : "38",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 22.0,
            "Variante"  : "black"
          },
          "ES982OB61BO34": {
            "image"     : "ES982OB61BO",
            "groesse"   : "34",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 1.0,
            "Variante"  : "bordeaux"
          },
          "ES982OB61DN36": {},
          "ES982OB61BO38": {
            "image"     : "ES982OB61BO",
            "groesse"   : "38",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 2.0,
            "Variante"  : "bordeaux"
          },
          "ES982OB61MA38": {
            "image"     : "ES982OB61MA",
            "groesse"   : "38",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 13.0,
            "Variante"  : "magenta"
          },
          "ES982OB61MA36": {
            "image"     : "ES982OB61MA",
            "groesse"   : "36",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 7.0,
            "Variante"  : "magenta"
          },
          "ES982OB61MA34": {
            "image"     : "ES982OB61MA",
            "groesse"   : "34",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "magenta"
          },
          "ES982OB61WT48": {
            "image"     : "ES982OB61WT",
            "groesse"   : "48",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "white"
          },
          "ES982OB61BK36": {
            "image"     : "ES982OB61BK",
            "groesse"   : "36",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 20.0,
            "Variante"  : "black"
          },
          "ES982OB61WT44": {
            "image"     : "ES982OB61WT",
            "groesse"   : "44",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 3.0,
            "Variante"  : "white"
          },
          "ES982OB61DN34": {},
          "ES982OB61BK34": {
            "image"     : "ES982OB61BK",
            "groesse"   : "34",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 1.0,
            "Variante"  : "black"
          },
          "ES982OB61WT46": {
            "image"     : "ES982OB61WT",
            "groesse"   : "46",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "white"
          },
          "ES982OB61MA44": {
            "image"     : "ES982OB61MA",
            "groesse"   : "44",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 2.0,
            "Variante"  : "magenta"
          },
          "ES982OB61WT40": {
            "image"     : "ES982OB61WT",
            "groesse"   : "40",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 23.0,
            "Variante"  : "white"
          },
          "ES982OB61BO46": {
            "image"     : "ES982OB61BO",
            "groesse"   : "46",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "bordeaux"
          },
          "ES982OB61DN48": {},
          "ES982OB61MA42": {
            "image"     : "ES982OB61MA",
            "groesse"   : "42",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 8.0,
            "Variante"  : "magenta"
          },
          "ES982OB61WT42": {
            "image"     : "ES982OB61WT",
            "groesse"   : "42",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 10.0,
            "Variante"  : "white"
          },
          "ES982OB61BK48": {
            "image"     : "ES982OB61BK",
            "groesse"   : "48",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "black"
          },
          "ES982OB61BO44": {
            "image"     : "ES982OB61BO",
            "groesse"   : "44",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "bordeaux"
          },
          "ES982OB61MA40": {
            "image"     : "ES982OB61MA",
            "groesse"   : "40",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 14.0,
            "Variante"  : "magenta"
          },
          "ES982OB61BO48": {
            "image"     : "ES982OB61BO",
            "groesse"   : "48",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "bordeaux"
          },
          "ES982OB61MA48": {
            "image"     : "ES982OB61MA",
            "groesse"   : "48",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "magenta"
          },
          "ES982OB61MA46": {
            "image"     : "ES982OB61MA",
            "groesse"   : "46",
            "quantities": [
              {
                "id"   : "Stueck",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "magenta"
          }
        }
      },
      "article_nr"  : "ES982OB61BK-34",
      "hash"        : "9d23552c3bdc370353829b7afad77e2b",
      "map_price_id": "ES982OB61BK34",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, black, 34",
        "map_id"   : "ES982OB61BK-34de",
        "remapid"  : "ES982OB61BK34",
        "extras"   : {},
        "label"    : "ES982OB61BK-34",
        "lang"     : "de",
        "short_des": "Lily Pants, black",
        "type"     : 0,
        "hash"     : "4cfbc556ab02a149cca6119841b113b8"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61BK",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61BK-36",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES982OB61BK",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "36",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "50.0",
        "Variante"    : "black"
      },
      "sort"        : "00855",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61BK36",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61BK36"
        }
      ],
      "map_id"      : "ES982OB61BK36",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61BK36",
      "article_nr"  : "ES982OB61BK-36",
      "stock"       : 16.0,
      "barcode"     : "4547469310739",
      "hash"        : "93437193f8432b30572366c850082c27",
      "map_price_id": "ES982OB61BK36",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, black, 36",
        "map_id"   : "ES982OB61BK-36de",
        "remapid"  : "ES982OB61BK36",
        "extras"   : {},
        "label"    : "ES982OB61BK-36",
        "lang"     : "de",
        "short_des": "Lily Pants, black",
        "type"     : 0,
        "hash"     : "f9740f438aed3a48710a61337cc676f3"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61BK",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61BK-38",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES982OB61BK",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "38",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "50.0",
        "Variante"    : "black"
      },
      "sort"        : "00855",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61BK38",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61BK38"
        }
      ],
      "map_id"      : "ES982OB61BK38",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61BK38",
      "article_nr"  : "ES982OB61BK-38",
      "stock"       : 18.0,
      "barcode"     : "4547469310746",
      "hash"        : "61931de8e9e934ab9815a3ce1ac5c507",
      "map_price_id": "ES982OB61BK38",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, black, 38",
        "map_id"   : "ES982OB61BK-38de",
        "remapid"  : "ES982OB61BK38",
        "extras"   : {},
        "label"    : "ES982OB61BK-38",
        "lang"     : "de",
        "short_des": "Lily Pants, black",
        "type"     : 0,
        "hash"     : "663c821a0fb311fe923d5f64bae94d95"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61BK",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61BK-40",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES982OB61BK",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "40",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "50.0",
        "Variante"    : "black"
      },
      "sort"        : "00855",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61BK40",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61BK40"
        }
      ],
      "map_id"      : "ES982OB61BK40",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61BK40",
      "article_nr"  : "ES982OB61BK-40",
      "stock"       : 16.0,
      "barcode"     : "4547469310678",
      "hash"        : "2e71d6e8d28322dec79d306cacd1282f",
      "map_price_id": "ES982OB61BK40",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, black, 40",
        "map_id"   : "ES982OB61BK-40de",
        "remapid"  : "ES982OB61BK40",
        "extras"   : {},
        "label"    : "ES982OB61BK-40",
        "lang"     : "de",
        "short_des": "Lily Pants, black",
        "type"     : 0,
        "hash"     : "2934319dd666c4b745d41e6c28a8d794"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61BK",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61BK-42",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "20-09-2019",
        "stamm_art"   : "ES982OB61BK",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "42",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "50.0",
        "Variante"    : "black"
      },
      "sort"        : "00855",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61BK42",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61BK42"
        }
      ],
      "map_id"      : "ES982OB61BK42",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61BK42",
      "article_nr"  : "ES982OB61BK-42",
      "stock"       : 0.0,
      "barcode"     : "4547469310685",
      "hash"        : "7a8719dc82d98d966cd46b2d3eddf1c8",
      "map_price_id": "ES982OB61BK42",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, black, 42",
        "map_id"   : "ES982OB61BK-42de",
        "remapid"  : "ES982OB61BK42",
        "extras"   : {},
        "label"    : "ES982OB61BK-42",
        "lang"     : "de",
        "short_des": "Lily Pants, black",
        "type"     : 0,
        "hash"     : "561a4545b58a7d84c31294715518fc0d"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61BK",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61BK-44",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "20-09-2019",
        "stamm_art"   : "ES982OB61BK",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "44",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "50.0",
        "Variante"    : "black"
      },
      "sort"        : "00855",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61BK44",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61BK44"
        }
      ],
      "map_id"      : "ES982OB61BK44",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61BK44",
      "article_nr"  : "ES982OB61BK-44",
      "stock"       : 0.0,
      "barcode"     : "4547469310692",
      "hash"        : "c418e21aa39ceb08aa37476f09ba505e",
      "map_price_id": "ES982OB61BK44",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, black, 44",
        "map_id"   : "ES982OB61BK-44de",
        "remapid"  : "ES982OB61BK44",
        "extras"   : {},
        "label"    : "ES982OB61BK-44",
        "lang"     : "de",
        "short_des": "Lily Pants, black",
        "type"     : 0,
        "hash"     : "9d43036c89da64c0e1b0235ecad3f55f"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61BK",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61BK-46",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "20-09-2019",
        "stamm_art"   : "ES982OB61BK",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "46",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "50.0",
        "Variante"    : "black"
      },
      "sort"        : "00855",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61BK46",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61BK46"
        }
      ],
      "map_id"      : "ES982OB61BK46",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61BK46",
      "article_nr"  : "ES982OB61BK-46",
      "stock"       : 0.0,
      "barcode"     : "4547469310708",
      "hash"        : "01f7f4bb9faf9ac25a0725a5bd2fe49e",
      "map_price_id": "ES982OB61BK46",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, black, 46",
        "map_id"   : "ES982OB61BK-46de",
        "remapid"  : "ES982OB61BK46",
        "extras"   : {},
        "label"    : "ES982OB61BK-46",
        "lang"     : "de",
        "short_des": "Lily Pants, black",
        "type"     : 0,
        "hash"     : "3d92fe7f4cfcf5316cd95fbf21a6ba02"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61BK",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61BK-48",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "20-09-2019",
        "stamm_art"   : "ES982OB61BK",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "48",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "50.0",
        "Variante"    : "black"
      },
      "sort"        : "00855",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61BK48",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61BK48"
        }
      ],
      "map_id"      : "ES982OB61BK48",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61BK48",
      "article_nr"  : "ES982OB61BK-48",
      "stock"       : 0.0,
      "barcode"     : "4547469310715",
      "hash"        : "78ad72c14c46319d8bbb81022c2a6487",
      "map_price_id": "ES982OB61BK48",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, black, 48",
        "map_id"   : "ES982OB61BK-48de",
        "remapid"  : "ES982OB61BK48",
        "extras"   : {},
        "label"    : "ES982OB61BK-48",
        "lang"     : "de",
        "short_des": "Lily Pants, black",
        "type"     : 0,
        "hash"     : "f45eb7d611520e775031f1b16bd4c6d3"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61BO",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61BO-34",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES982OB61BO",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "34",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "4.0",
        "Variante"    : "bordeaux"
      },
      "sort"        : "00240",
      "type"        : 1,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61BO34",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61BO34"
        }
      ],
      "map_id"      : "ES982OB61BO34",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61BO34",
      "article_nr"  : "ES982OB61BO-34",
      "stock"       : 0.0,
      "barcode"     : "4547469310005",
      "hash"        : "72134ce6139cf45461bdab88d2a9419d",
      "map_price_id": "ES982OB61BO34",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, bordeaux, 34",
        "map_id"   : "ES982OB61BO-34de",
        "remapid"  : "ES982OB61BO34",
        "extras"   : {},
        "label"    : "ES982OB61BO-34",
        "lang"     : "de",
        "short_des": "Lily Pants, bordeaux",
        "type"     : 0,
        "hash"     : "6a7bfd39c1836d18e4833c51effa6f07"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61BO",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61BO-36",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES982OB61BO",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "36",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "4.0",
        "Variante"    : "bordeaux"
      },
      "sort"        : "00240",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61BO36",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61BO36"
        }
      ],
      "map_id"      : "ES982OB61BO36",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61BO36",
      "article_nr"  : "ES982OB61BO-36",
      "stock"       : 1.0,
      "barcode"     : "4547469310012",
      "hash"        : "98405f3f7e6bd646fbc66870447cb800",
      "map_price_id": "ES982OB61BO36",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, bordeaux, 36",
        "map_id"   : "ES982OB61BO-36de",
        "remapid"  : "ES982OB61BO36",
        "extras"   : {},
        "label"    : "ES982OB61BO-36",
        "lang"     : "de",
        "short_des": "Lily Pants, bordeaux",
        "type"     : 0,
        "hash"     : "4a1a3b028f7625a0c9ec716e5521916f"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61BO",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61BO-38",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES982OB61BO",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "38",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "4.0",
        "Variante"    : "bordeaux"
      },
      "sort"        : "00240",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61BO38",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61BO38"
        }
      ],
      "map_id"      : "ES982OB61BO38",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61BO38",
      "article_nr"  : "ES982OB61BO-38",
      "stock"       : 1.0,
      "barcode"     : "4547469310029",
      "hash"        : "284b74b2b35f4b2618d2d833c63209c4",
      "map_price_id": "ES982OB61BO38",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, bordeaux, 38",
        "map_id"   : "ES982OB61BO-38de",
        "remapid"  : "ES982OB61BO38",
        "extras"   : {},
        "label"    : "ES982OB61BO-38",
        "lang"     : "de",
        "short_des": "Lily Pants, bordeaux",
        "type"     : 0,
        "hash"     : "ce0d0b40ebe8cc5f1e278288216a8ce3"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61BO",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61BO-40",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES982OB61BO",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "40",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "4.0",
        "Variante"    : "bordeaux"
      },
      "sort"        : "00240",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61BO40",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61BO40"
        }
      ],
      "map_id"      : "ES982OB61BO40",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61BO40",
      "article_nr"  : "ES982OB61BO-40",
      "stock"       : 1.0,
      "barcode"     : "4547469309955",
      "hash"        : "7c3e475d4ba746362eba1c6d58755531",
      "map_price_id": "ES982OB61BO40",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, bordeaux, 40",
        "map_id"   : "ES982OB61BO-40de",
        "remapid"  : "ES982OB61BO40",
        "extras"   : {},
        "label"    : "ES982OB61BO-40",
        "lang"     : "de",
        "short_des": "Lily Pants, bordeaux",
        "type"     : 0,
        "hash"     : "047da67da16352f5d8f561834a5a524e"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61BO",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61BO-42",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES982OB61BO",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "42",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "4.0",
        "Variante"    : "bordeaux"
      },
      "sort"        : "00240",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61BO42",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61BO42"
        }
      ],
      "map_id"      : "ES982OB61BO42",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61BO42",
      "article_nr"  : "ES982OB61BO-42",
      "stock"       : 1.0,
      "barcode"     : "4547469309962",
      "hash"        : "9d6be2e64219fa3b2fafce68c3a20d0f",
      "map_price_id": "ES982OB61BO42",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, bordeaux, 42",
        "map_id"   : "ES982OB61BO-42de",
        "remapid"  : "ES982OB61BO42",
        "extras"   : {},
        "label"    : "ES982OB61BO-42",
        "lang"     : "de",
        "short_des": "Lily Pants, bordeaux",
        "type"     : 0,
        "hash"     : "e9e1dc2e4fb6bb6cb5a0467012dddf1e"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61BO",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61BO-44",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "20-09-2019",
        "stamm_art"   : "ES982OB61BO",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "44",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "4.0",
        "Variante"    : "bordeaux"
      },
      "sort"        : "00240",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61BO44",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61BO44"
        }
      ],
      "map_id"      : "ES982OB61BO44",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61BO44",
      "article_nr"  : "ES982OB61BO-44",
      "stock"       : 0.0,
      "barcode"     : "4547469309979",
      "hash"        : "99f89c0e8de95fac0f90ea70239e1ca8",
      "map_price_id": "ES982OB61BO44",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, bordeaux, 44",
        "map_id"   : "ES982OB61BO-44de",
        "remapid"  : "ES982OB61BO44",
        "extras"   : {},
        "label"    : "ES982OB61BO-44",
        "lang"     : "de",
        "short_des": "Lily Pants, bordeaux",
        "type"     : 0,
        "hash"     : "89c3f25a9db83d7718251bdfad66c892"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61BO",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61BO-46",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "20-09-2019",
        "stamm_art"   : "ES982OB61BO",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "46",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "4.0",
        "Variante"    : "bordeaux"
      },
      "sort"        : "00240",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61BO46",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61BO46"
        }
      ],
      "map_id"      : "ES982OB61BO46",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61BO46",
      "article_nr"  : "ES982OB61BO-46",
      "stock"       : 0.0,
      "barcode"     : "4547469309986",
      "hash"        : "e891fb15e5496ba183caf58cb96dadc8",
      "map_price_id": "ES982OB61BO46",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, bordeaux, 46",
        "map_id"   : "ES982OB61BO-46de",
        "remapid"  : "ES982OB61BO46",
        "extras"   : {},
        "label"    : "ES982OB61BO-46",
        "lang"     : "de",
        "short_des": "Lily Pants, bordeaux",
        "type"     : 0,
        "hash"     : "22020c481c734c7443f2354153aec296"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61BO",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61BO-48",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "20-09-2019",
        "stamm_art"   : "ES982OB61BO",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "48",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "4.0",
        "Variante"    : "bordeaux"
      },
      "sort"        : "00240",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61BO48",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61BO48"
        }
      ],
      "map_id"      : "ES982OB61BO48",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61BO48",
      "article_nr"  : "ES982OB61BO-48",
      "stock"       : 0.0,
      "barcode"     : "4547469309993",
      "hash"        : "7a640cb6eed301e2999b105fe804f882",
      "map_price_id": "ES982OB61BO48",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, bordeaux, 48",
        "map_id"   : "ES982OB61BO-48de",
        "remapid"  : "ES982OB61BO48",
        "extras"   : {},
        "label"    : "ES982OB61BO-48",
        "lang"     : "de",
        "short_des": "Lily Pants, bordeaux",
        "type"     : 0,
        "hash"     : "72222bd6e2ae3ec4adae9718f4ccb1ea"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61DN",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61DN-34",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "20-09-2019",
        "stamm_art"   : "ES982OB61DN",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "34",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "1.0",
        "Variante"    : "dark navy"
      },
      "sort"        : "00005",
      "type"        : 1,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61DN34",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61DN34"
        }
      ],
      "map_id"      : "ES982OB61DN34",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61DN34",
      "article_nr"  : "ES982OB61DN-34",
      "stock"       : 0.0,
      "barcode"     : "4547469310241",
      "hash"        : "6b77c3b290f1b32b762c0ac0401f98a2",
      "map_price_id": "ES982OB61DN34",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, dark navy, 34",
        "map_id"   : "ES982OB61DN-34de",
        "remapid"  : "ES982OB61DN34",
        "extras"   : {},
        "label"    : "ES982OB61DN-34",
        "lang"     : "de",
        "short_des": "Lily Pants, dark navy",
        "type"     : 0,
        "hash"     : "d8c3b47a11f41627d5f76b35a95dab1e"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61DN",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61DN-36",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "20-09-2019",
        "stamm_art"   : "ES982OB61DN",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "36",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "1.0",
        "Variante"    : "dark navy"
      },
      "sort"        : "00005",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61DN36",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61DN36"
        }
      ],
      "map_id"      : "ES982OB61DN36",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61DN36",
      "article_nr"  : "ES982OB61DN-36",
      "stock"       : 0.0,
      "barcode"     : "4547469310258",
      "hash"        : "4c9fcaef72e0b1f7a25684e1b3944641",
      "map_price_id": "ES982OB61DN36",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, dark navy, 36",
        "map_id"   : "ES982OB61DN-36de",
        "remapid"  : "ES982OB61DN36",
        "extras"   : {},
        "label"    : "ES982OB61DN-36",
        "lang"     : "de",
        "short_des": "Lily Pants, dark navy",
        "type"     : 0,
        "hash"     : "7e9630b0e087d2d760c856a8fb07ce22"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61DN",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61DN-38",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "20-09-2019",
        "stamm_art"   : "ES982OB61DN",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "38",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "1.0",
        "Variante"    : "dark navy"
      },
      "sort"        : "00005",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61DN38",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61DN38"
        }
      ],
      "map_id"      : "ES982OB61DN38",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61DN38",
      "article_nr"  : "ES982OB61DN-38",
      "stock"       : 0.0,
      "barcode"     : "4547469310265",
      "hash"        : "248f2f5ae4de6c82deeac89599817acd",
      "map_price_id": "ES982OB61DN38",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, dark navy, 38",
        "map_id"   : "ES982OB61DN-38de",
        "remapid"  : "ES982OB61DN38",
        "extras"   : {},
        "label"    : "ES982OB61DN-38",
        "lang"     : "de",
        "short_des": "Lily Pants, dark navy",
        "type"     : 0,
        "hash"     : "9936a285b572e058f026195b746d4437"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61DN",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61DN-40",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "20-09-2019",
        "stamm_art"   : "ES982OB61DN",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "40",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "1.0",
        "Variante"    : "dark navy"
      },
      "sort"        : "00005",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61DN40",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61DN40"
        }
      ],
      "map_id"      : "ES982OB61DN40",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61DN40",
      "article_nr"  : "ES982OB61DN-40",
      "stock"       : 0.0,
      "barcode"     : "4547469310197",
      "hash"        : "eb5ba0f0a402875bae26188edce53c03",
      "map_price_id": "ES982OB61DN40",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, dark navy, 40",
        "map_id"   : "ES982OB61DN-40de",
        "remapid"  : "ES982OB61DN40",
        "extras"   : {},
        "label"    : "ES982OB61DN-40",
        "lang"     : "de",
        "short_des": "Lily Pants, dark navy",
        "type"     : 0,
        "hash"     : "3d439f2c57fcaed9e91904bd6d355834"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61DN",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61DN-42",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "20-09-2019",
        "stamm_art"   : "ES982OB61DN",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "42",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "1.0",
        "Variante"    : "dark navy"
      },
      "sort"        : "00005",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61DN42",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61DN42"
        }
      ],
      "map_id"      : "ES982OB61DN42",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61DN42",
      "article_nr"  : "ES982OB61DN-42",
      "stock"       : 0.0,
      "barcode"     : "4547469310203",
      "hash"        : "1ba9766438329a8e3031fc0f74ff52f4",
      "map_price_id": "ES982OB61DN42",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, dark navy, 42",
        "map_id"   : "ES982OB61DN-42de",
        "remapid"  : "ES982OB61DN42",
        "extras"   : {},
        "label"    : "ES982OB61DN-42",
        "lang"     : "de",
        "short_des": "Lily Pants, dark navy",
        "type"     : 0,
        "hash"     : "c2938edb70e487f77ea7a17f7ba9897c"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61DN",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61DN-44",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES982OB61DN",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "44",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "1.0",
        "Variante"    : "dark navy"
      },
      "sort"        : "00005",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61DN44",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61DN44"
        }
      ],
      "map_id"      : "ES982OB61DN44",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61DN44",
      "article_nr"  : "ES982OB61DN-44",
      "stock"       : 1.0,
      "barcode"     : "4547469310210",
      "hash"        : "ed6cdec300878642dedcdb37d5177a27",
      "map_price_id": "ES982OB61DN44",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, dark navy, 44",
        "map_id"   : "ES982OB61DN-44de",
        "remapid"  : "ES982OB61DN44",
        "extras"   : {},
        "label"    : "ES982OB61DN-44",
        "lang"     : "de",
        "short_des": "Lily Pants, dark navy",
        "type"     : 0,
        "hash"     : "217a114104b5b7570963f03b6046c402"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61DN",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61DN-46",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "20-09-2019",
        "stamm_art"   : "ES982OB61DN",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "46",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "1.0",
        "Variante"    : "dark navy"
      },
      "sort"        : "00005",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61DN46",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61DN46"
        }
      ],
      "map_id"      : "ES982OB61DN46",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61DN46",
      "article_nr"  : "ES982OB61DN-46",
      "stock"       : 0.0,
      "barcode"     : "4547469310227",
      "hash"        : "99d25894511b762e520f0ad322619a90",
      "map_price_id": "ES982OB61DN46",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, dark navy, 46",
        "map_id"   : "ES982OB61DN-46de",
        "remapid"  : "ES982OB61DN46",
        "extras"   : {},
        "label"    : "ES982OB61DN-46",
        "lang"     : "de",
        "short_des": "Lily Pants, dark navy",
        "type"     : 0,
        "hash"     : "fa76b6679a821756884c1d58bbe03971"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61DN",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61DN-48",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "20-09-2019",
        "stamm_art"   : "ES982OB61DN",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "48",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "1.0",
        "Variante"    : "dark navy"
      },
      "sort"        : "00005",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61DN48",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61DN48"
        }
      ],
      "map_id"      : "ES982OB61DN48",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61DN48",
      "article_nr"  : "ES982OB61DN-48",
      "stock"       : 0.0,
      "barcode"     : "4547469310234",
      "hash"        : "176932d6a9da6e015428108adf85e8db",
      "map_price_id": "ES982OB61DN48",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, dark navy, 48",
        "map_id"   : "ES982OB61DN-48de",
        "remapid"  : "ES982OB61DN48",
        "extras"   : {},
        "label"    : "ES982OB61DN-48",
        "lang"     : "de",
        "short_des": "Lily Pants, dark navy",
        "type"     : 0,
        "hash"     : "c12ff013f43fd43729b5122d0d9c4706"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61MA",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61MA-34",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "20-09-2019",
        "stamm_art"   : "ES982OB61MA",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "34",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "34.0",
        "Variante"    : "magenta"
      },
      "sort"        : "00578",
      "type"        : 1,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61MA34",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61MA34"
        }
      ],
      "map_id"      : "ES982OB61MA34",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61MA34",
      "article_nr"  : "ES982OB61MA-34",
      "stock"       : 0.0,
      "barcode"     : "4547469310401",
      "hash"        : "d697e5de45cd0533ccce0ef206890028",
      "map_price_id": "ES982OB61MA34",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, magenta, 34",
        "map_id"   : "ES982OB61MA-34de",
        "remapid"  : "ES982OB61MA34",
        "extras"   : {},
        "label"    : "ES982OB61MA-34",
        "lang"     : "de",
        "short_des": "Lily Pants, magenta",
        "type"     : 0,
        "hash"     : "df42e921380c362ee6f6cb5747ef7108"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61MA",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61MA-36",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES982OB61MA",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "36",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "34.0",
        "Variante"    : "magenta"
      },
      "sort"        : "00578",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61MA36",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61MA36"
        }
      ],
      "map_id"      : "ES982OB61MA36",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61MA36",
      "article_nr"  : "ES982OB61MA-36",
      "stock"       : 6.0,
      "barcode"     : "4547469310418",
      "hash"        : "5ac85a36ddbc3928d676de3c0dd8fad7",
      "map_price_id": "ES982OB61MA36",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, magenta, 36",
        "map_id"   : "ES982OB61MA-36de",
        "remapid"  : "ES982OB61MA36",
        "extras"   : {},
        "label"    : "ES982OB61MA-36",
        "lang"     : "de",
        "short_des": "Lily Pants, magenta",
        "type"     : 0,
        "hash"     : "f93701e66fcea296626fc78cb80d4c54"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61MA",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61MA-38",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES982OB61MA",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "38",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "34.0",
        "Variante"    : "magenta"
      },
      "sort"        : "00578",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61MA38",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61MA38"
        }
      ],
      "map_id"      : "ES982OB61MA38",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61MA38",
      "article_nr"  : "ES982OB61MA-38",
      "stock"       : 9.0,
      "barcode"     : "4547469310425",
      "hash"        : "ea5e61776a0dabcab46964a7b03c3265",
      "map_price_id": "ES982OB61MA38",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, magenta, 38",
        "map_id"   : "ES982OB61MA-38de",
        "remapid"  : "ES982OB61MA38",
        "extras"   : {},
        "label"    : "ES982OB61MA-38",
        "lang"     : "de",
        "short_des": "Lily Pants, magenta",
        "type"     : 0,
        "hash"     : "79eadc666328398ed510b1e89b5b868b"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61MA",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61MA-40",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES982OB61MA",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "40",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "34.0",
        "Variante"    : "magenta"
      },
      "sort"        : "00578",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61MA40",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61MA40"
        }
      ],
      "map_id"      : "ES982OB61MA40",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61MA40",
      "article_nr"  : "ES982OB61MA-40",
      "stock"       : 11.0,
      "barcode"     : "4547469310357",
      "hash"        : "af9f9377ad19ada8a64ae198227c1fef",
      "map_price_id": "ES982OB61MA40",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, magenta, 40",
        "map_id"   : "ES982OB61MA-40de",
        "remapid"  : "ES982OB61MA40",
        "extras"   : {},
        "label"    : "ES982OB61MA-40",
        "lang"     : "de",
        "short_des": "Lily Pants, magenta",
        "type"     : 0,
        "hash"     : "fb697065bf164e13e74e6259103889f4"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61MA",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61MA-42",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES982OB61MA",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "42",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "34.0",
        "Variante"    : "magenta"
      },
      "sort"        : "00578",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61MA42",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61MA42"
        }
      ],
      "map_id"      : "ES982OB61MA42",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61MA42",
      "article_nr"  : "ES982OB61MA-42",
      "stock"       : 7.0,
      "barcode"     : "4547469310364",
      "hash"        : "834449fefb9d0a98e789f999fc4f0657",
      "map_price_id": "ES982OB61MA42",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, magenta, 42",
        "map_id"   : "ES982OB61MA-42de",
        "remapid"  : "ES982OB61MA42",
        "extras"   : {},
        "label"    : "ES982OB61MA-42",
        "lang"     : "de",
        "short_des": "Lily Pants, magenta",
        "type"     : 0,
        "hash"     : "b0a43fb853436757711d85ccca4e166b"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61MA",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61MA-44",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES982OB61MA",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "44",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "34.0",
        "Variante"    : "magenta"
      },
      "sort"        : "00578",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61MA44",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61MA44"
        }
      ],
      "map_id"      : "ES982OB61MA44",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61MA44",
      "article_nr"  : "ES982OB61MA-44",
      "stock"       : 1.0,
      "barcode"     : "4547469310371",
      "hash"        : "b801f8b8eff415543508edcfc47a22a8",
      "map_price_id": "ES982OB61MA44",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, magenta, 44",
        "map_id"   : "ES982OB61MA-44de",
        "remapid"  : "ES982OB61MA44",
        "extras"   : {},
        "label"    : "ES982OB61MA-44",
        "lang"     : "de",
        "short_des": "Lily Pants, magenta",
        "type"     : 0,
        "hash"     : "26ec7c02805b99f466947c8b641a394c"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61MA",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61MA-46",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "20-09-2019",
        "stamm_art"   : "ES982OB61MA",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "46",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "34.0",
        "Variante"    : "magenta"
      },
      "sort"        : "00578",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61MA46",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61MA46"
        }
      ],
      "map_id"      : "ES982OB61MA46",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61MA46",
      "article_nr"  : "ES982OB61MA-46",
      "stock"       : 0.0,
      "barcode"     : "4547469310388",
      "hash"        : "916c290e09280094d2f4c890713c477a",
      "map_price_id": "ES982OB61MA46",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, magenta, 46",
        "map_id"   : "ES982OB61MA-46de",
        "remapid"  : "ES982OB61MA46",
        "extras"   : {},
        "label"    : "ES982OB61MA-46",
        "lang"     : "de",
        "short_des": "Lily Pants, magenta",
        "type"     : 0,
        "hash"     : "b0403189a5f1766b7649f3dff35edcad"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61MA",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61MA-48",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "20-09-2019",
        "stamm_art"   : "ES982OB61MA",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "48",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "34.0",
        "Variante"    : "magenta"
      },
      "sort"        : "00578",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61MA48",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61MA48"
        }
      ],
      "map_id"      : "ES982OB61MA48",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61MA48",
      "article_nr"  : "ES982OB61MA-48",
      "stock"       : 0.0,
      "barcode"     : "4547469310395",
      "hash"        : "24e274fb2da785e4d3dd9cb50f98b987",
      "map_price_id": "ES982OB61MA48",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, magenta, 48",
        "map_id"   : "ES982OB61MA-48de",
        "remapid"  : "ES982OB61MA48",
        "extras"   : {},
        "label"    : "ES982OB61MA-48",
        "lang"     : "de",
        "short_des": "Lily Pants, magenta",
        "type"     : 0,
        "hash"     : "34463fae2ecd2320ff4c4daeee064819"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61WT",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61WT-34",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "20-09-2019",
        "stamm_art"   : "ES982OB61WT",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "34",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "41.0",
        "Variante"    : "white"
      },
      "sort"        : "00717",
      "type"        : 1,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61WT34",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61WT34"
        }
      ],
      "map_id"      : "ES982OB61WT34",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61WT34",
      "article_nr"  : "ES982OB61WT-34",
      "stock"       : 0.0,
      "barcode"     : "4547469310487",
      "hash"        : "83d3352c05835586862768793e015b3f",
      "map_price_id": "ES982OB61WT34",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, white, 34",
        "map_id"   : "ES982OB61WT-34de",
        "remapid"  : "ES982OB61WT34",
        "extras"   : {},
        "label"    : "ES982OB61WT-34",
        "lang"     : "de",
        "short_des": "Lily Pants, white",
        "type"     : 0,
        "hash"     : "2d7d5995494d210d1c8477e026f6651c"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61WT",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61WT-36",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES982OB61WT",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "36",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "41.0",
        "Variante"    : "white"
      },
      "sort"        : "00717",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61WT36",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61WT36"
        }
      ],
      "map_id"      : "ES982OB61WT36",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61WT36",
      "article_nr"  : "ES982OB61WT-36",
      "stock"       : 1.0,
      "barcode"     : "4547469310494",
      "hash"        : "0f70a2b42b6bdc0cc05282e4b1282a35",
      "map_price_id": "ES982OB61WT36",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, white, 36",
        "map_id"   : "ES982OB61WT-36de",
        "remapid"  : "ES982OB61WT36",
        "extras"   : {},
        "label"    : "ES982OB61WT-36",
        "lang"     : "de",
        "short_des": "Lily Pants, white",
        "type"     : 0,
        "hash"     : "3a526d2b4548212d8c66bf127d4cfb4a"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61WT",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61WT-38",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES982OB61WT",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "38",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "41.0",
        "Variante"    : "white"
      },
      "sort"        : "00717",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61WT38",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61WT38"
        }
      ],
      "map_id"      : "ES982OB61WT38",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61WT38",
      "article_nr"  : "ES982OB61WT-38",
      "stock"       : 9.0,
      "barcode"     : "4547469310500",
      "hash"        : "b46af422da29e5cebc165f1a4079d0a6",
      "map_price_id": "ES982OB61WT38",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, white, 38",
        "map_id"   : "ES982OB61WT-38de",
        "remapid"  : "ES982OB61WT38",
        "extras"   : {},
        "label"    : "ES982OB61WT-38",
        "lang"     : "de",
        "short_des": "Lily Pants, white",
        "type"     : 0,
        "hash"     : "37f2decef2cbdfc2246b900f53ab10a7"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61WT",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61WT-40",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES982OB61WT",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "40",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "41.0",
        "Variante"    : "white"
      },
      "sort"        : "00717",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61WT40",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61WT40"
        }
      ],
      "map_id"      : "ES982OB61WT40",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61WT40",
      "article_nr"  : "ES982OB61WT-40",
      "stock"       : 20.0,
      "barcode"     : "4547469310432",
      "hash"        : "2a6b3a5d1d2bbe78c041319dbe4c1d55",
      "map_price_id": "ES982OB61WT40",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, white, 40",
        "map_id"   : "ES982OB61WT-40de",
        "remapid"  : "ES982OB61WT40",
        "extras"   : {},
        "label"    : "ES982OB61WT-40",
        "lang"     : "de",
        "short_des": "Lily Pants, white",
        "type"     : 0,
        "hash"     : "786e3d653e02c702313439eeeaed18f6"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61WT",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61WT-42",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES982OB61WT",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "42",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "41.0",
        "Variante"    : "white"
      },
      "sort"        : "00717",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61WT42",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61WT42"
        }
      ],
      "map_id"      : "ES982OB61WT42",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61WT42",
      "article_nr"  : "ES982OB61WT-42",
      "stock"       : 9.0,
      "barcode"     : "4547469310449",
      "hash"        : "506c4bfa8b3e5c21ea7d560404dd3121",
      "map_price_id": "ES982OB61WT42",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, white, 42",
        "map_id"   : "ES982OB61WT-42de",
        "remapid"  : "ES982OB61WT42",
        "extras"   : {},
        "label"    : "ES982OB61WT-42",
        "lang"     : "de",
        "short_des": "Lily Pants, white",
        "type"     : 0,
        "hash"     : "c04b43a628f4bf799733adc0d20886e9"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61WT",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61WT-44",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "ES982OB61WT",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "44",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "41.0",
        "Variante"    : "white"
      },
      "sort"        : "00717",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61WT44",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61WT44"
        }
      ],
      "map_id"      : "ES982OB61WT44",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61WT44",
      "article_nr"  : "ES982OB61WT-44",
      "stock"       : 2.0,
      "barcode"     : "4547469310456",
      "hash"        : "aca3f72f118aa6eaae44e78cfbd5b001",
      "map_price_id": "ES982OB61WT44",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, white, 44",
        "map_id"   : "ES982OB61WT-44de",
        "remapid"  : "ES982OB61WT44",
        "extras"   : {},
        "label"    : "ES982OB61WT-44",
        "lang"     : "de",
        "short_des": "Lily Pants, white",
        "type"     : 0,
        "hash"     : "19293525a57caf59b649e91db553e7d8"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61WT",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61WT-46",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "20-09-2019",
        "stamm_art"   : "ES982OB61WT",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "46",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "41.0",
        "Variante"    : "white"
      },
      "sort"        : "00717",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61WT46",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61WT46"
        }
      ],
      "map_id"      : "ES982OB61WT46",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61WT46",
      "article_nr"  : "ES982OB61WT-46",
      "stock"       : 0.0,
      "barcode"     : "4547469310463",
      "hash"        : "88ae72c99f142c2caefca9f7df4810ed",
      "map_price_id": "ES982OB61WT46",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, white, 46",
        "map_id"   : "ES982OB61WT-46de",
        "remapid"  : "ES982OB61WT46",
        "extras"   : {},
        "label"    : "ES982OB61WT-46",
        "lang"     : "de",
        "short_des": "Lily Pants, white",
        "type"     : 0,
        "hash"     : "3f8ae7ca6fe9a30cfef069fd504d0845"
      }
    },
    {
      "mainart"     : "ES982OB61BK34",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "ES982OB61WT",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Stueck",
          "map_desc_id": "Stueck",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Phenix",
        "winline_art" : "ES982OB61WT-48",
        "sofortorder" : "true",
        "orderable"   : "false",
        "verfuegbarab": "20-09-2019",
        "stamm_art"   : "ES982OB61WT",
        "vororder"    : "false",
        "uvp"         : "269.95",
        "groesse"     : "48",
        "sale"        : "false",
        "cat_id"      : "00030-00002-00005-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "41.0",
        "Variante"    : "white"
      },
      "sort"        : "00717",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "128.55"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "ES982OB61WT48",
          "cat_id"    : "00030-00002-00005-00000-00000",
          "sort"      : "ES982OB61WT48"
        }
      ],
      "map_id"      : "ES982OB61WT48",
      "price"       : 128.55,
      "map_desc_id" : "ES982OB61WT48",
      "article_nr"  : "ES982OB61WT-48",
      "stock"       : 0.0,
      "barcode"     : "4547469310470",
      "hash"        : "7acbe18cf40e1f0aab9946947eb3f414",
      "map_price_id": "ES982OB61WT48",
      "desc"        : {
        "search"   : "Phenix",
        "des"      : "Lily Pants, white, 48",
        "map_id"   : "ES982OB61WT-48de",
        "remapid"  : "ES982OB61WT48",
        "extras"   : {},
        "label"    : "ES982OB61WT-48",
        "lang"     : "de",
        "short_des": "Lily Pants, white",
        "type"     : 0,
        "hash"     : "eaa1c351b2ff9d3bf43e7f15d25edace"
      }
    },
    {
      "mainart"     : "SF1402",
      "reordered"   : true,
      "map_pic_id"  : "SF-1400",
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-1402",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-1400",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "A (32.0-33.5)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "87.0",
        "Variante"    : "TRIM-TO-FIT Green"
      },
      "type"        : 1,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "map_id"      : "SF1402",
      "price"       : 21.43,
      "map_desc_id" : "SF1402",
      "stock"       : 5.0,
      "barcode"     : "086301514026",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "vat"         : 19,
      "sort"        : "00137",
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF1402",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF1402"
        }
      ],
      "parts"       : {
        "variants": [
          "Variante",
          "groesse"
        ],
        "articles": [
          "SF1402",
          "SF1404",
          "SF1406",
          "SF1408",
          "SF1410",
          "SF1412",
          "SF1414",
          "SF15006",
          "SF15008",
          "SF15010",
          "SF15012",
          "SF15014",
          "SF2401",
          "SF2402",
          "SF2404",
          "SF2406",
          "SF2408",
          "SF2410",
          "SF2412",
          "SF2414",
          "SF28004",
          "SF28006",
          "SF28008",
          "SF28010",
          "SF28012",
          "SF28014",
          "SF32004",
          "SF32006",
          "SF32008",
          "SF32010",
          "SF32012",
          "SF32014",
          "SF3404",
          "SF3406",
          "SF3408",
          "SF3410",
          "SF3412",
          "SF3414",
          "SF37004",
          "SF37006",
          "SF37008",
          "SF37010",
          "SF37012",
          "SF37014",
          "SF6405",
          "SF6407",
          "SF6409",
          "SF6411",
          "SF71005",
          "SF71007",
          "SF71009",
          "SF71011",
          "SF72006",
          "SF72008",
          "SF72010",
          "SF72012",
          "SF72014",
          "SF7406",
          "SF7408",
          "SF7410",
          "SF7412",
          "SF7414"
        ],
        "info"    : {
          "SF3412" : {
            "image"     : "SF-3400",
            "groesse"   : "F (45.0-46.5)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 13.0,
            "Variante"  : "TRIM-TO-FIT Black"
          },
          "SF2401" : {
            "image"     : "SF-2400",
            "groesse"   : "J (29.0-31.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "TRIM-TO-FIT Blue"
          },
          "SF2402" : {
            "image"     : "SF-2400",
            "groesse"   : "A (32.0-33.5)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 4.0,
            "Variante"  : "TRIM-TO-FIT Blue"
          },
          "SF3414" : {
            "image"     : "SF-3400",
            "groesse"   : "G (47.0-49.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 5.0,
            "Variante"  : "TRIM-TO-FIT Black"
          },
          "SF6405" : {
            "image"     : "SF-6400",
            "groesse"   : "B (34.0-36.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 2.0,
            "Variante"  : "TRIM-TO-FIT Berry"
          },
          "SF7414" : {
            "image"     : "SF-7400",
            "groesse"   : "G (47.0-49.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "TRIM-TO-FIT Orange"
          },
          "SF3410" : {
            "image"     : "SF-3400",
            "groesse"   : "E (42.0-44.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 18.0,
            "Variante"  : "TRIM-TO-FIT Black"
          },
          "SF7412" : {
            "image"     : "SF-7400",
            "groesse"   : "F (45.0-46.5)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 6.0,
            "Variante"  : "TRIM-TO-FIT Orange"
          },
          "SF2408" : {
            "image"     : "SF-2400",
            "groesse"   : "D (39.0-41.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 5.0,
            "Variante"  : "TRIM-TO-FIT Blue"
          },
          "SF2404" : {
            "image"     : "SF-2400",
            "groesse"   : "B (34.0-36.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 6.0,
            "Variante"  : "TRIM-TO-FIT Blue"
          },
          "SF6407" : {
            "image"     : "SF-6400",
            "groesse"   : "C (37.0-38.5)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 1.0,
            "Variante"  : "TRIM-TO-FIT Berry"
          },
          "SF2406" : {
            "image"     : "SF-2400",
            "groesse"   : "C (37.0-38.5)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 7.0,
            "Variante"  : "TRIM-TO-FIT Blue"
          },
          "SF6409" : {
            "image"     : "SF-6400",
            "groesse"   : "D (39.0-41.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "TRIM-TO-FIT Berry"
          },
          "SF72014": {
            "image"     : "SF-72000",
            "groesse"   : "G (47.0-49.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "TRIM-TO-FIT Red Hot"
          },
          "SF72012": {
            "image"     : "SF-72000",
            "groesse"   : "F (45.0-46.5)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 23.0,
            "Variante"  : "TRIM-TO-FIT Red Hot"
          },
          "SF72010": {
            "image"     : "SF-72000",
            "groesse"   : "E (42.0-44.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 6.0,
            "Variante"  : "TRIM-TO-FIT Red Hot"
          },
          "SF7410" : {
            "image"     : "SF-7400",
            "groesse"   : "E (42.0-44.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 6.0,
            "Variante"  : "TRIM-TO-FIT Orange"
          },
          "SF71009": {
            "image"     : "SF-71000",
            "groesse"   : "D (39.0-41.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 5.0,
            "Variante"  : "TRIM-TO-FIT Hot Pink"
          },
          "SF71007": {
            "image"     : "SF-71000",
            "groesse"   : "C (37.0-38.5)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 7.0,
            "Variante"  : "TRIM-TO-FIT Hot Pink"
          },
          "SF71005": {
            "image"     : "SF-71000",
            "groesse"   : "B (34.0-36.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 2.0,
            "Variante"  : "TRIM-TO-FIT Hot Pink"
          },
          "SF2410" : {
            "image"     : "SF-2400",
            "groesse"   : "E (42.0-44.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 16.0,
            "Variante"  : "TRIM-TO-FIT Blue"
          },
          "SF2412" : {
            "image"     : "SF-2400",
            "groesse"   : "F (45.0-46.5)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 6.0,
            "Variante"  : "TRIM-TO-FIT Blue"
          },
          "SF6411" : {
            "image"     : "SF-6400",
            "groesse"   : "E (42.0-44.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "TRIM-TO-FIT Berry"
          },
          "SF28010": {
            "image"     : "SF-28000",
            "groesse"   : "E (42.0-44.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 7.0,
            "Variante"  : "TRIM-TO-FIT Merino Grey"
          },
          "SF1404" : {
            "image"     : "SF-1400",
            "groesse"   : "B (34.0-36.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 13.0,
            "Variante"  : "TRIM-TO-FIT Green"
          },
          "SF28014": {
            "image"     : "SF-28000",
            "groesse"   : "G (47.0-49.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "TRIM-TO-FIT Merino Grey"
          },
          "SF1402" : {
            "image"     : "SF-1400",
            "groesse"   : "A (32.0-33.5)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 5.0,
            "Variante"  : "TRIM-TO-FIT Green"
          },
          "SF28012": {
            "image"     : "SF-28000",
            "groesse"   : "F (45.0-46.5)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 1.0,
            "Variante"  : "TRIM-TO-FIT Merino Grey"
          },
          "SF2414" : {
            "image"     : "SF-2400",
            "groesse"   : "G (47.0-49.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 13.0,
            "Variante"  : "TRIM-TO-FIT Blue"
          },
          "SF1408" : {
            "image"     : "SF-1400",
            "groesse"   : "D (39.0-41.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 33.0,
            "Variante"  : "TRIM-TO-FIT Green"
          },
          "SF1406" : {
            "image"     : "SF-1400",
            "groesse"   : "C (37.0-38.5)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 12.0,
            "Variante"  : "TRIM-TO-FIT Green"
          },
          "SF72008": {
            "image"     : "SF-72000",
            "groesse"   : "D (39.0-41.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 9.0,
            "Variante"  : "TRIM-TO-FIT Red Hot"
          },
          "SF72006": {
            "image"     : "SF-72000",
            "groesse"   : "C (37.0-38.5)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 3.0,
            "Variante"  : "TRIM-TO-FIT Red Hot"
          },
          "SF15008": {
            "image"     : "SF-15000",
            "groesse"   : "D (39.0-41.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "TRIM-TO-FIT Wide Green"
          },
          "SF1412" : {
            "image"     : "SF-1400",
            "groesse"   : "F (45.0-46.5)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 13.0,
            "Variante"  : "TRIM-TO-FIT Green"
          },
          "SF1410" : {
            "image"     : "SF-1400",
            "groesse"   : "E (42.0-44.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 23.0,
            "Variante"  : "TRIM-TO-FIT Green"
          },
          "SF28004": {
            "image"     : "SF-28000",
            "groesse"   : "B (34.0-36.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 4.0,
            "Variante"  : "TRIM-TO-FIT Merino Grey"
          },
          "SF1414" : {
            "image"     : "SF-1400",
            "groesse"   : "G (47.0-49.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 13.0,
            "Variante"  : "TRIM-TO-FIT Green"
          },
          "SF28008": {
            "image"     : "SF-28000",
            "groesse"   : "D (39.0-41.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 10.0,
            "Variante"  : "TRIM-TO-FIT Merino Grey"
          },
          "SF28006": {
            "image"     : "SF-28000",
            "groesse"   : "C (37.0-38.5)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 1.0,
            "Variante"  : "TRIM-TO-FIT Merino Grey"
          },
          "SF15012": {
            "image"     : "SF-15000",
            "groesse"   : "F (45.0-46.5)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "TRIM-TO-FIT Wide Green"
          },
          "SF15010": {
            "image"     : "SF-15000",
            "groesse"   : "E (42.0-44.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "TRIM-TO-FIT Wide Green"
          },
          "SF37004": {
            "image"     : "SF-37000",
            "groesse"   : "B (34.0-36.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "TRIM-TO-FIT DMP Copper"
          },
          "SF15014": {
            "image"     : "SF-15000",
            "groesse"   : "G (47.0-49.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "TRIM-TO-FIT Wide Green"
          },
          "SF32014": {
            "image"     : "SF-32000",
            "groesse"   : "G (47.0-49.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 12.0,
            "Variante"  : "TRIM-TO-FIT Carbon"
          },
          "SF37006": {
            "image"     : "SF-37000",
            "groesse"   : "C (37.0-38.5)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "TRIM-TO-FIT DMP Copper"
          },
          "SF7406" : {
            "image"     : "SF-7400",
            "groesse"   : "C (37.0-38.5)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 4.0,
            "Variante"  : "TRIM-TO-FIT Orange"
          },
          "SF32012": {
            "image"     : "SF-32000",
            "groesse"   : "F (45.0-46.5)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 16.0,
            "Variante"  : "TRIM-TO-FIT Carbon"
          },
          "SF37008": {
            "image"     : "SF-37000",
            "groesse"   : "D (39.0-41.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "TRIM-TO-FIT DMP Copper"
          },
          "SF32010": {
            "image"     : "SF-32000",
            "groesse"   : "E (42.0-44.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 5.0,
            "Variante"  : "TRIM-TO-FIT Carbon"
          },
          "SF3408" : {
            "image"     : "SF-3400",
            "groesse"   : "D (39.0-41.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 17.0,
            "Variante"  : "TRIM-TO-FIT Black"
          },
          "SF3404" : {
            "image"     : "SF-3400",
            "groesse"   : "B (34.0-36.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 15.0,
            "Variante"  : "TRIM-TO-FIT Black"
          },
          "SF3406" : {
            "image"     : "SF-3400",
            "groesse"   : "C (37.0-38.5)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 19.0,
            "Variante"  : "TRIM-TO-FIT Black"
          },
          "SF7408" : {
            "image"     : "SF-7400",
            "groesse"   : "D (39.0-41.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 6.0,
            "Variante"  : "TRIM-TO-FIT Orange"
          },
          "SF71011": {
            "image"     : "SF-71000",
            "groesse"   : "E (42.0-44.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 11.0,
            "Variante"  : "TRIM-TO-FIT Hot Pink"
          },
          "SF32008": {
            "image"     : "SF-32000",
            "groesse"   : "D (39.0-41.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 4.0,
            "Variante"  : "TRIM-TO-FIT Carbon"
          },
          "SF37010": {
            "image"     : "SF-37000",
            "groesse"   : "E (42.0-44.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "TRIM-TO-FIT DMP Copper"
          },
          "SF32006": {
            "image"     : "SF-32000",
            "groesse"   : "C (37.0-38.5)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 2.0,
            "Variante"  : "TRIM-TO-FIT Carbon"
          },
          "SF37012": {
            "image"     : "SF-37000",
            "groesse"   : "F (45.0-46.5)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "TRIM-TO-FIT DMP Copper"
          },
          "SF15006": {
            "image"     : "SF-15000",
            "groesse"   : "C (37.0-38.5)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "TRIM-TO-FIT Wide Green"
          },
          "SF32004": {
            "image"     : "SF-32000",
            "groesse"   : "B (34.0-36.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 8.0,
            "Variante"  : "TRIM-TO-FIT Carbon"
          },
          "SF37014": {
            "image"     : "SF-37000",
            "groesse"   : "G (47.0-49.0)",
            "quantities": [
              {
                "id"   : "Paar",
                "multi": "1,00"
              }
            ],
            "stock"     : 0.0,
            "Variante"  : "TRIM-TO-FIT DMP Copper"
          }
        }
      },
      "article_nr"  : "SF-1402",
      "hash"        : "e8d1b60df426c4d4523f8679e6364097",
      "map_price_id": "SF1402",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Green, A (32.0-33.5)",
        "map_id"   : "SF-1402de",
        "remapid"  : "SF1402",
        "extras"   : {},
        "label"    : "SF-1402",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Green",
        "type"     : 0,
        "hash"     : "a6013299b60de6ef9e5d3976849a3198"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-1400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-1404",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-1400",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "B (34.0-36.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "87.0",
        "Variante"    : "TRIM-TO-FIT Green"
      },
      "sort"        : "00137",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF1404",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF1404"
        }
      ],
      "map_id"      : "SF1404",
      "price"       : 21.43,
      "map_desc_id" : "SF1404",
      "article_nr"  : "SF-1404",
      "stock"       : 13.0,
      "barcode"     : "086301514040",
      "hash"        : "60fdc9b75ed31c45254b779717b7e1c8",
      "map_price_id": "SF1404",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Green, B (34.0-36.0)",
        "map_id"   : "SF-1404de",
        "remapid"  : "SF1404",
        "extras"   : {},
        "label"    : "SF-1404",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Green",
        "type"     : 0,
        "hash"     : "9431c064d72c169137c91dbf06413862"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-1400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-1406",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-1400",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "C (37.0-38.5)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "87.0",
        "Variante"    : "TRIM-TO-FIT Green"
      },
      "sort"        : "00137",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF1406",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF1406"
        }
      ],
      "map_id"      : "SF1406",
      "price"       : 21.43,
      "map_desc_id" : "SF1406",
      "article_nr"  : "SF-1406",
      "stock"       : 9.0,
      "barcode"     : "086301514064",
      "hash"        : "fb5686318c13c8e852aea989f702eb2e",
      "map_price_id": "SF1406",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Green, C (37.0-38.5)",
        "map_id"   : "SF-1406de",
        "remapid"  : "SF1406",
        "extras"   : {},
        "label"    : "SF-1406",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Green",
        "type"     : 0,
        "hash"     : "1fc68357f8f02e5c90ea789af10b7865"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-1400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-1408",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-1400",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "D (39.0-41.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "87.0",
        "Variante"    : "TRIM-TO-FIT Green"
      },
      "sort"        : "00137",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF1408",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF1408"
        }
      ],
      "map_id"      : "SF1408",
      "price"       : 21.43,
      "map_desc_id" : "SF1408",
      "article_nr"  : "SF-1408",
      "stock"       : 29.0,
      "barcode"     : "086301514088",
      "hash"        : "9745bd0ffab38f2afb25f675d74f847b",
      "map_price_id": "SF1408",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Green, D (39.0-41.0)",
        "map_id"   : "SF-1408de",
        "remapid"  : "SF1408",
        "extras"   : {},
        "label"    : "SF-1408",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Green",
        "type"     : 0,
        "hash"     : "ccf0e801aa2ca1ffb433f3a751b395ee"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-1400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-1410",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-1400",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "E (42.0-44.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "87.0",
        "Variante"    : "TRIM-TO-FIT Green"
      },
      "sort"        : "00137",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF1410",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF1410"
        }
      ],
      "map_id"      : "SF1410",
      "price"       : 21.43,
      "map_desc_id" : "SF1410",
      "article_nr"  : "SF-1410",
      "stock"       : 7.0,
      "barcode"     : "086301514101",
      "hash"        : "24d3e79ae2f4357543fe48a8cc512fd0",
      "map_price_id": "SF1410",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Green, E (42.0-44.0)",
        "map_id"   : "SF-1410de",
        "remapid"  : "SF1410",
        "extras"   : {},
        "label"    : "SF-1410",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Green",
        "type"     : 0,
        "hash"     : "e5fa182c64a48226d81594c994cbee1b"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-1400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-1412",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-1400",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "F (45.0-46.5)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "87.0",
        "Variante"    : "TRIM-TO-FIT Green"
      },
      "sort"        : "00137",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF1412",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF1412"
        }
      ],
      "map_id"      : "SF1412",
      "price"       : 21.43,
      "map_desc_id" : "SF1412",
      "article_nr"  : "SF-1412",
      "stock"       : 11.0,
      "barcode"     : "086301514125",
      "hash"        : "50549fe9dcb50efdfd1887943598b9d8",
      "map_price_id": "SF1412",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Green, F (45.0-46.5)",
        "map_id"   : "SF-1412de",
        "remapid"  : "SF1412",
        "extras"   : {},
        "label"    : "SF-1412",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Green",
        "type"     : 0,
        "hash"     : "f6d617b8bb02d8e54fa6e0b927b33cd1"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-1400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-1414",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-1400",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "G (47.0-49.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "87.0",
        "Variante"    : "TRIM-TO-FIT Green"
      },
      "sort"        : "00137",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF1414",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF1414"
        }
      ],
      "map_id"      : "SF1414",
      "price"       : 21.43,
      "map_desc_id" : "SF1414",
      "article_nr"  : "SF-1414",
      "stock"       : 13.0,
      "barcode"     : "086301514149",
      "hash"        : "e85b8fab0a51b5205a2e20576bd397f8",
      "map_price_id": "SF1414",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Green, G (47.0-49.0)",
        "map_id"   : "SF-1414de",
        "remapid"  : "SF1414",
        "extras"   : {},
        "label"    : "SF-1414",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Green",
        "type"     : 0,
        "hash"     : "58e4ae690585cda6ccd06e65de73bfc2"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-15000",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-15006",
        "sofortorder" : "false",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-15000",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "C (37.0-38.5)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "0.0",
        "Variante"    : "TRIM-TO-FIT Wide Green"
      },
      "sort"        : "00000",
      "type"        : 1,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF15006",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF15006"
        }
      ],
      "map_id"      : "SF15006",
      "price"       : 21.43,
      "map_desc_id" : "SF15006",
      "article_nr"  : "SF-15006",
      "stock"       : 0.0,
      "barcode"     : "086301150064",
      "hash"        : "aa7b6af0097cdda70aaf5639c4fdc9c7",
      "map_price_id": "SF15006",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Wide Green, C (37.0-38.5)",
        "map_id"   : "SF-15006de",
        "remapid"  : "SF15006",
        "extras"   : {},
        "label"    : "SF-15006",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Wide Green",
        "type"     : 0,
        "hash"     : "ab1af54e4839d6983ad30dfdb72da499"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-15000",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-15008",
        "sofortorder" : "false",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-15000",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "D (39.0-41.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "0.0",
        "Variante"    : "TRIM-TO-FIT Wide Green"
      },
      "sort"        : "00000",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF15008",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF15008"
        }
      ],
      "map_id"      : "SF15008",
      "price"       : 21.43,
      "map_desc_id" : "SF15008",
      "article_nr"  : "SF-15008",
      "stock"       : 0.0,
      "barcode"     : "086301150088",
      "hash"        : "ce4473a40aa3dcacf98c3ddc8f9b5f51",
      "map_price_id": "SF15008",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Wide Green, D (39.0-41.0)",
        "map_id"   : "SF-15008de",
        "remapid"  : "SF15008",
        "extras"   : {},
        "label"    : "SF-15008",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Wide Green",
        "type"     : 0,
        "hash"     : "b352e9c67089507dc6d16ec1837a7fad"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-15000",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-15010",
        "sofortorder" : "false",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-15000",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "E (42.0-44.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "0.0",
        "Variante"    : "TRIM-TO-FIT Wide Green"
      },
      "sort"        : "00000",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF15010",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF15010"
        }
      ],
      "map_id"      : "SF15010",
      "price"       : 21.43,
      "map_desc_id" : "SF15010",
      "article_nr"  : "SF-15010",
      "stock"       : 0.0,
      "barcode"     : "086301150101",
      "hash"        : "bf96a868229a768d6932770b0ba24c8e",
      "map_price_id": "SF15010",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Wide Green, E (42.0-44.0)",
        "map_id"   : "SF-15010de",
        "remapid"  : "SF15010",
        "extras"   : {},
        "label"    : "SF-15010",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Wide Green",
        "type"     : 0,
        "hash"     : "4939346f336be898e9c3c13dd1d52202"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-15000",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-15012",
        "sofortorder" : "false",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-15000",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "F (45.0-46.5)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "0.0",
        "Variante"    : "TRIM-TO-FIT Wide Green"
      },
      "sort"        : "00000",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF15012",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF15012"
        }
      ],
      "map_id"      : "SF15012",
      "price"       : 21.43,
      "map_desc_id" : "SF15012",
      "article_nr"  : "SF-15012",
      "stock"       : 0.0,
      "barcode"     : "086301150125",
      "hash"        : "2dfa7ab527448bd4021d27b1330e747d",
      "map_price_id": "SF15012",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Wide Green, F (45.0-46.5)",
        "map_id"   : "SF-15012de",
        "remapid"  : "SF15012",
        "extras"   : {},
        "label"    : "SF-15012",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Wide Green",
        "type"     : 0,
        "hash"     : "8e543e818e4fbb48ee64f9ea6706e131"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-15000",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-15014",
        "sofortorder" : "false",
        "orderable"   : "false",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-15000",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "G (47.0-49.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "0.0",
        "Variante"    : "TRIM-TO-FIT Wide Green"
      },
      "sort"        : "00000",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF15014",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF15014"
        }
      ],
      "map_id"      : "SF15014",
      "price"       : 21.43,
      "map_desc_id" : "SF15014",
      "article_nr"  : "SF-15014",
      "stock"       : 0.0,
      "barcode"     : "086301150149",
      "hash"        : "a828b23fae532926c92e2b1001f81b8c",
      "map_price_id": "SF15014",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Wide Green, G (47.0-49.0)",
        "map_id"   : "SF-15014de",
        "remapid"  : "SF15014",
        "extras"   : {},
        "label"    : "SF-15014",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Wide Green",
        "type"     : 0,
        "hash"     : "ab45b4e4af7e8b693cd61d607bfdeea4"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-2400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-2401",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-2400",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "J (29.0-31.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "36.0",
        "Variante"    : "TRIM-TO-FIT Blue"
      },
      "sort"        : "00078",
      "type"        : 1,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF2401",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF2401"
        }
      ],
      "map_id"      : "SF2401",
      "price"       : 21.43,
      "map_desc_id" : "SF2401",
      "article_nr"  : "SF-2401",
      "stock"       : 0.0,
      "barcode"     : "086301524018",
      "hash"        : "3789708c24a2f0e1c67fc6443196eba6",
      "map_price_id": "SF2401",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Blue, J (29.0-31.0)",
        "map_id"   : "SF-2401de",
        "remapid"  : "SF2401",
        "extras"   : {},
        "label"    : "SF-2401",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Blue",
        "type"     : 0,
        "hash"     : "232401560c9eda95886df9a383d2c288"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-2400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-2402",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-2400",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "A (32.0-33.5)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "36.0",
        "Variante"    : "TRIM-TO-FIT Blue"
      },
      "sort"        : "00078",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF2402",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF2402"
        }
      ],
      "map_id"      : "SF2402",
      "price"       : 21.43,
      "map_desc_id" : "SF2402",
      "article_nr"  : "SF-2402",
      "stock"       : 4.0,
      "barcode"     : "086301524025",
      "hash"        : "9b13282ccd3f1460b102650f3b05d874",
      "map_price_id": "SF2402",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Blue, A (32.0-33.5)",
        "map_id"   : "SF-2402de",
        "remapid"  : "SF2402",
        "extras"   : {},
        "label"    : "SF-2402",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Blue",
        "type"     : 0,
        "hash"     : "fdfef2f4fbd923c28a6a210a34dc1253"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-2400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-2404",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-2400",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "B (34.0-36.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "36.0",
        "Variante"    : "TRIM-TO-FIT Blue"
      },
      "sort"        : "00078",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF2404",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF2404"
        }
      ],
      "map_id"      : "SF2404",
      "price"       : 21.43,
      "map_desc_id" : "SF2404",
      "article_nr"  : "SF-2404",
      "stock"       : 6.0,
      "barcode"     : "086301524049",
      "hash"        : "cbbe4a4d25f97e0e4fd625153da229db",
      "map_price_id": "SF2404",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Blue, B (34.0-36.0)",
        "map_id"   : "SF-2404de",
        "remapid"  : "SF2404",
        "extras"   : {},
        "label"    : "SF-2404",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Blue",
        "type"     : 0,
        "hash"     : "d5f653aab7021085dc9e85e076d00fbc"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-2400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-2406",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-2400",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "C (37.0-38.5)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "36.0",
        "Variante"    : "TRIM-TO-FIT Blue"
      },
      "sort"        : "00078",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF2406",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF2406"
        }
      ],
      "map_id"      : "SF2406",
      "price"       : 21.43,
      "map_desc_id" : "SF2406",
      "article_nr"  : "SF-2406",
      "stock"       : 2.0,
      "barcode"     : "086301524063",
      "hash"        : "fda57f262c879cd00671139d537683f5",
      "map_price_id": "SF2406",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Blue, C (37.0-38.5)",
        "map_id"   : "SF-2406de",
        "remapid"  : "SF2406",
        "extras"   : {},
        "label"    : "SF-2406",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Blue",
        "type"     : 0,
        "hash"     : "520b301a1e94af02a0617b7feabc26f3"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-2400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-2408",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-2400",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "D (39.0-41.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "36.0",
        "Variante"    : "TRIM-TO-FIT Blue"
      },
      "sort"        : "00078",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF2408",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF2408"
        }
      ],
      "map_id"      : "SF2408",
      "price"       : 21.43,
      "map_desc_id" : "SF2408",
      "article_nr"  : "SF-2408",
      "stock"       : 0.0,
      "barcode"     : "086301524087",
      "hash"        : "5e3b76718534757d68573422b49b8a38",
      "map_price_id": "SF2408",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Blue, D (39.0-41.0)",
        "map_id"   : "SF-2408de",
        "remapid"  : "SF2408",
        "extras"   : {},
        "label"    : "SF-2408",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Blue",
        "type"     : 0,
        "hash"     : "9607723929d46152fc6791e255d20278"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-2400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-2410",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-2400",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "E (42.0-44.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "36.0",
        "Variante"    : "TRIM-TO-FIT Blue"
      },
      "sort"        : "00078",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF2410",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF2410"
        }
      ],
      "map_id"      : "SF2410",
      "price"       : 21.43,
      "map_desc_id" : "SF2410",
      "article_nr"  : "SF-2410",
      "stock"       : 9.0,
      "barcode"     : "086301524100",
      "hash"        : "099881e9604c64ac4ea6c5efd9c42be4",
      "map_price_id": "SF2410",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Blue, E (42.0-44.0)",
        "map_id"   : "SF-2410de",
        "remapid"  : "SF2410",
        "extras"   : {},
        "label"    : "SF-2410",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Blue",
        "type"     : 0,
        "hash"     : "0c59f97f58ce5b8d324d31c70861d9b3"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-2400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-2412",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-2400",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "F (45.0-46.5)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "36.0",
        "Variante"    : "TRIM-TO-FIT Blue"
      },
      "sort"        : "00078",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF2412",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF2412"
        }
      ],
      "map_id"      : "SF2412",
      "price"       : 21.43,
      "map_desc_id" : "SF2412",
      "article_nr"  : "SF-2412",
      "stock"       : 2.0,
      "barcode"     : "086301524124",
      "hash"        : "377c319eee505dee7b6b53ea65fed247",
      "map_price_id": "SF2412",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Blue, F (45.0-46.5)",
        "map_id"   : "SF-2412de",
        "remapid"  : "SF2412",
        "extras"   : {},
        "label"    : "SF-2412",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Blue",
        "type"     : 0,
        "hash"     : "0d5fca6f45006060563f5de9a7ea2313"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-2400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-2414",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-2400",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "G (47.0-49.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "36.0",
        "Variante"    : "TRIM-TO-FIT Blue"
      },
      "sort"        : "00078",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF2414",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF2414"
        }
      ],
      "map_id"      : "SF2414",
      "price"       : 21.43,
      "map_desc_id" : "SF2414",
      "article_nr"  : "SF-2414",
      "stock"       : 13.0,
      "barcode"     : "086301524148",
      "hash"        : "1cc2814b9da4fe3ee0d286b5b675488c",
      "map_price_id": "SF2414",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Blue, G (47.0-49.0)",
        "map_id"   : "SF-2414de",
        "remapid"  : "SF2414",
        "extras"   : {},
        "label"    : "SF-2414",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Blue",
        "type"     : 0,
        "hash"     : "ca2fc6cbef21dea12c48b68b2aa57cb9"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-28000",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-28004",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-28000",
        "vororder"    : "true",
        "uvp"         : "55.0",
        "groesse"     : "B (34.0-36.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "23.0",
        "Variante"    : "TRIM-TO-FIT Merino Grey"
      },
      "sort"        : "00081",
      "type"        : 1,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF28004",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF28004"
        }
      ],
      "map_id"      : "SF28004",
      "price"       : 26.19,
      "map_desc_id" : "SF28004",
      "article_nr"  : "SF-28004",
      "stock"       : 2.0,
      "barcode"     : "086301280044",
      "hash"        : "1f8b77782e6aa7840cf10590c3511af0",
      "map_price_id": "SF28004",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Merino Grey, B (34.0-36.0)",
        "map_id"   : "SF-28004de",
        "remapid"  : "SF28004",
        "extras"   : {},
        "label"    : "SF-28004",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Merino Grey",
        "type"     : 0,
        "hash"     : "bc77676ed608359460e16830502441ca"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-28000",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-28006",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-28000",
        "vororder"    : "true",
        "uvp"         : "55.0",
        "groesse"     : "C (37.0-38.5)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "23.0",
        "Variante"    : "TRIM-TO-FIT Merino Grey"
      },
      "sort"        : "00081",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF28006",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF28006"
        }
      ],
      "map_id"      : "SF28006",
      "price"       : 26.19,
      "map_desc_id" : "SF28006",
      "article_nr"  : "SF-28006",
      "stock"       : 5.0,
      "barcode"     : "086301280068",
      "hash"        : "165cc717469e511a19650616f7d893be",
      "map_price_id": "SF28006",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Merino Grey, C (37.0-38.5)",
        "map_id"   : "SF-28006de",
        "remapid"  : "SF28006",
        "extras"   : {},
        "label"    : "SF-28006",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Merino Grey",
        "type"     : 0,
        "hash"     : "8f319d94374e9e1316594bcd582fc3da"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-28000",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-28008",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-28000",
        "vororder"    : "true",
        "uvp"         : "55.0",
        "groesse"     : "D (39.0-41.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "23.0",
        "Variante"    : "TRIM-TO-FIT Merino Grey"
      },
      "sort"        : "00081",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF28008",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF28008"
        }
      ],
      "map_id"      : "SF28008",
      "price"       : 26.19,
      "map_desc_id" : "SF28008",
      "article_nr"  : "SF-28008",
      "stock"       : 10.0,
      "barcode"     : "086301280082",
      "hash"        : "29b4cc7b6befc8238bc3d57bdb9a1a22",
      "map_price_id": "SF28008",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Merino Grey, D (39.0-41.0)",
        "map_id"   : "SF-28008de",
        "remapid"  : "SF28008",
        "extras"   : {},
        "label"    : "SF-28008",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Merino Grey",
        "type"     : 0,
        "hash"     : "3c431a8cca363750f050345a0e1c7aaa"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-28000",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-28010",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-28000",
        "vororder"    : "true",
        "uvp"         : "55.0",
        "groesse"     : "E (42.0-44.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "23.0",
        "Variante"    : "TRIM-TO-FIT Merino Grey"
      },
      "sort"        : "00081",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF28010",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF28010"
        }
      ],
      "map_id"      : "SF28010",
      "price"       : 26.19,
      "map_desc_id" : "SF28010",
      "article_nr"  : "SF-28010",
      "stock"       : 1.0,
      "barcode"     : "086301280105",
      "hash"        : "e35ba9f716280b8655741c049e204e45",
      "map_price_id": "SF28010",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Merino Grey, E (42.0-44.0)",
        "map_id"   : "SF-28010de",
        "remapid"  : "SF28010",
        "extras"   : {},
        "label"    : "SF-28010",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Merino Grey",
        "type"     : 0,
        "hash"     : "504869d32d9df00942d4f72cdf7a1028"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-28000",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-28012",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-28000",
        "vororder"    : "true",
        "uvp"         : "55.0",
        "groesse"     : "F (45.0-46.5)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "23.0",
        "Variante"    : "TRIM-TO-FIT Merino Grey"
      },
      "sort"        : "00081",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF28012",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF28012"
        }
      ],
      "map_id"      : "SF28012",
      "price"       : 26.19,
      "map_desc_id" : "SF28012",
      "article_nr"  : "SF-28012",
      "stock"       : 5.0,
      "barcode"     : "086301280129",
      "hash"        : "3651c2ca26947c07970ff4fa3d6181cb",
      "map_price_id": "SF28012",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Merino Grey, F (45.0-46.5)",
        "map_id"   : "SF-28012de",
        "remapid"  : "SF28012",
        "extras"   : {},
        "label"    : "SF-28012",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Merino Grey",
        "type"     : 0,
        "hash"     : "90eb0da2999c41bc4364bbc827486bce"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-28000",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-28014",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-28000",
        "vororder"    : "true",
        "uvp"         : "55.0",
        "groesse"     : "G (47.0-49.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "23.0",
        "Variante"    : "TRIM-TO-FIT Merino Grey"
      },
      "sort"        : "00081",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF28014",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF28014"
        }
      ],
      "map_id"      : "SF28014",
      "price"       : 26.19,
      "map_desc_id" : "SF28014",
      "article_nr"  : "SF-28014",
      "stock"       : 0.0,
      "barcode"     : "086301280143",
      "hash"        : "cf1b6e01817dc3ca8dbc435e0f80c86b",
      "map_price_id": "SF28014",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Merino Grey, G (47.0-49.0)",
        "map_id"   : "SF-28014de",
        "remapid"  : "SF28014",
        "extras"   : {},
        "label"    : "SF-28014",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Merino Grey",
        "type"     : 0,
        "hash"     : "3295948e84ee39e63c2415bca660c10b"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-32000",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-32004",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-32000",
        "vororder"    : "true",
        "uvp"         : "55.0",
        "groesse"     : "B (34.0-36.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "41.0",
        "Variante"    : "TRIM-TO-FIT Carbon"
      },
      "sort"        : "00093",
      "type"        : 1,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF32004",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF32004"
        }
      ],
      "map_id"      : "SF32004",
      "price"       : 26.19,
      "map_desc_id" : "SF32004",
      "article_nr"  : "SF-32004",
      "stock"       : 8.0,
      "barcode"     : "086301320047",
      "hash"        : "0b1246b20caa5b9be8a23ff8d030d300",
      "map_price_id": "SF32004",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Carbon, B (34.0-36.0)",
        "map_id"   : "SF-32004de",
        "remapid"  : "SF32004",
        "extras"   : {},
        "label"    : "SF-32004",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Carbon",
        "type"     : 0,
        "hash"     : "68837f43060a56ecf24e7f315de0b454"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-32000",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-32006",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-32000",
        "vororder"    : "true",
        "uvp"         : "55.0",
        "groesse"     : "C (37.0-38.5)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "41.0",
        "Variante"    : "TRIM-TO-FIT Carbon"
      },
      "sort"        : "00093",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF32006",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF32006"
        }
      ],
      "map_id"      : "SF32006",
      "price"       : 26.19,
      "map_desc_id" : "SF32006",
      "article_nr"  : "SF-32006",
      "stock"       : 2.0,
      "barcode"     : "086301320061",
      "hash"        : "9f2a0b645ae027928dd77d4fe879dc97",
      "map_price_id": "SF32006",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Carbon, C (37.0-38.5)",
        "map_id"   : "SF-32006de",
        "remapid"  : "SF32006",
        "extras"   : {},
        "label"    : "SF-32006",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Carbon",
        "type"     : 0,
        "hash"     : "089f085e61aa5ff60aed18c7625808a6"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-32000",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-32008",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-32000",
        "vororder"    : "true",
        "uvp"         : "55.0",
        "groesse"     : "D (39.0-41.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "41.0",
        "Variante"    : "TRIM-TO-FIT Carbon"
      },
      "sort"        : "00093",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF32008",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF32008"
        }
      ],
      "map_id"      : "SF32008",
      "price"       : 26.19,
      "map_desc_id" : "SF32008",
      "article_nr"  : "SF-32008",
      "stock"       : 8.0,
      "barcode"     : "086301320085",
      "hash"        : "eef3c59c65ce8fbc2f67263574b2d67b",
      "map_price_id": "SF32008",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Carbon, D (39.0-41.0)",
        "map_id"   : "SF-32008de",
        "remapid"  : "SF32008",
        "extras"   : {},
        "label"    : "SF-32008",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Carbon",
        "type"     : 0,
        "hash"     : "0a59241fd164f5d782c69e63b8b02907"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-32000",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-32010",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-32000",
        "vororder"    : "true",
        "uvp"         : "55.0",
        "groesse"     : "E (42.0-44.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "41.0",
        "Variante"    : "TRIM-TO-FIT Carbon"
      },
      "sort"        : "00093",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF32010",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF32010"
        }
      ],
      "map_id"      : "SF32010",
      "price"       : 26.19,
      "map_desc_id" : "SF32010",
      "article_nr"  : "SF-32010",
      "stock"       : 3.0,
      "barcode"     : "086301320108",
      "hash"        : "983f20b75e03f4c13d9c865552ca8265",
      "map_price_id": "SF32010",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Carbon, E (42.0-44.0)",
        "map_id"   : "SF-32010de",
        "remapid"  : "SF32010",
        "extras"   : {},
        "label"    : "SF-32010",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Carbon",
        "type"     : 0,
        "hash"     : "0a1bd25e79dffba21150fb80a73ac77e"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-32000",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-32012",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-32000",
        "vororder"    : "true",
        "uvp"         : "55.0",
        "groesse"     : "F (45.0-46.5)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "41.0",
        "Variante"    : "TRIM-TO-FIT Carbon"
      },
      "sort"        : "00093",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF32012",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF32012"
        }
      ],
      "map_id"      : "SF32012",
      "price"       : 26.19,
      "map_desc_id" : "SF32012",
      "article_nr"  : "SF-32012",
      "stock"       : 8.0,
      "barcode"     : "086301320122",
      "hash"        : "a7807c8fc9ff9c61baff1dd1e8dc0e33",
      "map_price_id": "SF32012",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Carbon, F (45.0-46.5)",
        "map_id"   : "SF-32012de",
        "remapid"  : "SF32012",
        "extras"   : {},
        "label"    : "SF-32012",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Carbon",
        "type"     : 0,
        "hash"     : "2eb2b72ec413317f46cd8d6153693393"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-32000",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-32014",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-32000",
        "vororder"    : "true",
        "uvp"         : "55.0",
        "groesse"     : "G (47.0-49.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "41.0",
        "Variante"    : "TRIM-TO-FIT Carbon"
      },
      "sort"        : "00093",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF32014",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF32014"
        }
      ],
      "map_id"      : "SF32014",
      "price"       : 26.19,
      "map_desc_id" : "SF32014",
      "article_nr"  : "SF-32014",
      "stock"       : 12.0,
      "barcode"     : "086301320146",
      "hash"        : "55a8ab25161fc7045369c534c8b976ea",
      "map_price_id": "SF32014",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Carbon, G (47.0-49.0)",
        "map_id"   : "SF-32014de",
        "remapid"  : "SF32014",
        "extras"   : {},
        "label"    : "SF-32014",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Carbon",
        "type"     : 0,
        "hash"     : "fb4793c67cf0adc57d0b14be0cdf0a70"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-3400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-3404",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-3400",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "B (34.0-36.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "67.0",
        "Variante"    : "TRIM-TO-FIT Black"
      },
      "sort"        : "00109",
      "type"        : 1,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF3404",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF3404"
        }
      ],
      "map_id"      : "SF3404",
      "price"       : 21.43,
      "map_desc_id" : "SF3404",
      "article_nr"  : "SF-3404",
      "stock"       : 15.0,
      "barcode"     : "086301534048",
      "hash"        : "78dd3e26a190195af82ac28c3f7864cb",
      "map_price_id": "SF3404",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Black, B (34.0-36.0)",
        "map_id"   : "SF-3404de",
        "remapid"  : "SF3404",
        "extras"   : {},
        "label"    : "SF-3404",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Black",
        "type"     : 0,
        "hash"     : "7a06e179f43aad59ef885f3dcaa0b26b"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-3400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-3406",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-3400",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "C (37.0-38.5)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "67.0",
        "Variante"    : "TRIM-TO-FIT Black"
      },
      "sort"        : "00109",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF3406",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF3406"
        }
      ],
      "map_id"      : "SF3406",
      "price"       : 21.43,
      "map_desc_id" : "SF3406",
      "article_nr"  : "SF-3406",
      "stock"       : 16.0,
      "barcode"     : "086301534062",
      "hash"        : "8cd44a1b92e87b75311bf666a45165e0",
      "map_price_id": "SF3406",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Black, C (37.0-38.5)",
        "map_id"   : "SF-3406de",
        "remapid"  : "SF3406",
        "extras"   : {},
        "label"    : "SF-3406",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Black",
        "type"     : 0,
        "hash"     : "be9d8594ca86f3b3362d861356d88c8c"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-3400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-3408",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-3400",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "D (39.0-41.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "67.0",
        "Variante"    : "TRIM-TO-FIT Black"
      },
      "sort"        : "00109",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF3408",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF3408"
        }
      ],
      "map_id"      : "SF3408",
      "price"       : 21.43,
      "map_desc_id" : "SF3408",
      "article_nr"  : "SF-3408",
      "stock"       : 12.0,
      "barcode"     : "086301534086",
      "hash"        : "a8fe5a666955f9338b91c1f11e852ae9",
      "map_price_id": "SF3408",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Black, D (39.0-41.0)",
        "map_id"   : "SF-3408de",
        "remapid"  : "SF3408",
        "extras"   : {},
        "label"    : "SF-3408",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Black",
        "type"     : 0,
        "hash"     : "52e5314886c7030d53fdeea2cb115bb4"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-3400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-3410",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-3400",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "E (42.0-44.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "67.0",
        "Variante"    : "TRIM-TO-FIT Black"
      },
      "sort"        : "00109",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF3410",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF3410"
        }
      ],
      "map_id"      : "SF3410",
      "price"       : 21.43,
      "map_desc_id" : "SF3410",
      "article_nr"  : "SF-3410",
      "stock"       : 9.0,
      "barcode"     : "086301534109",
      "hash"        : "89a66d6ffa257ee9173be0497b827678",
      "map_price_id": "SF3410",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Black, E (42.0-44.0)",
        "map_id"   : "SF-3410de",
        "remapid"  : "SF3410",
        "extras"   : {},
        "label"    : "SF-3410",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Black",
        "type"     : 0,
        "hash"     : "c0d6d25c97ea482f07ca81470dae985a"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-3400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-3412",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-3400",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "F (45.0-46.5)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "67.0",
        "Variante"    : "TRIM-TO-FIT Black"
      },
      "sort"        : "00109",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF3412",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF3412"
        }
      ],
      "map_id"      : "SF3412",
      "price"       : 21.43,
      "map_desc_id" : "SF3412",
      "article_nr"  : "SF-3412",
      "stock"       : 13.0,
      "barcode"     : "086301534123",
      "hash"        : "4aa70b6ca927000d67c4c2d0aecb351d",
      "map_price_id": "SF3412",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Black, F (45.0-46.5)",
        "map_id"   : "SF-3412de",
        "remapid"  : "SF3412",
        "extras"   : {},
        "label"    : "SF-3412",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Black",
        "type"     : 0,
        "hash"     : "00acdb1208c4bd6f2592414130fc86be"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-3400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-3414",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-3400",
        "vororder"    : "true",
        "uvp"         : "45.0",
        "groesse"     : "G (47.0-49.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "67.0",
        "Variante"    : "TRIM-TO-FIT Black"
      },
      "sort"        : "00109",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "21.43"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF3414",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF3414"
        }
      ],
      "map_id"      : "SF3414",
      "price"       : 21.43,
      "map_desc_id" : "SF3414",
      "article_nr"  : "SF-3414",
      "stock"       : 2.0,
      "barcode"     : "086301534147",
      "hash"        : "98fda81e2ed4930ee9477e23b5ed022f",
      "map_price_id": "SF3414",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Black, G (47.0-49.0)",
        "map_id"   : "SF-3414de",
        "remapid"  : "SF3414",
        "extras"   : {},
        "label"    : "SF-3414",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Black",
        "type"     : 0,
        "hash"     : "d9119700c01d87be19f861ef904fddad"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : false,
      "map_pic_id"  : "SF-37000",
      "vat"         : 7,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-37004",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-37000",
        "vororder"    : "true",
        "uvp"         : "60.0",
        "groesse"     : "B (34.0-36.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "0.0",
        "Variante"    : "TRIM-TO-FIT DMP Copper"
      },
      "sort"        : "00000",
      "type"        : 1,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF37004",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF37004"
        }
      ],
      "map_id"      : "SF37004",
      "price"       : 26.19,
      "map_desc_id" : "SF37004",
      "article_nr"  : "SF-37004",
      "stock"       : 0.0,
      "barcode"     : "086301370042",
      "hash"        : "29e889eda89c16eae28a9bffeac2e9f4",
      "map_price_id": "SF37004",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT DMP Copper, B (34.0-36.0)",
        "map_id"   : "SF-37004de",
        "remapid"  : "SF37004",
        "extras"   : {},
        "label"    : "SF-37004",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT DMP Copper",
        "type"     : 0,
        "hash"     : "953a5944e6975b59e28ca708375d34f5"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : false,
      "map_pic_id"  : "SF-37000",
      "vat"         : 7,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-37006",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-37000",
        "vororder"    : "true",
        "uvp"         : "60.0",
        "groesse"     : "C (37.0-38.5)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "0.0",
        "Variante"    : "TRIM-TO-FIT DMP Copper"
      },
      "sort"        : "00000",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF37006",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF37006"
        }
      ],
      "map_id"      : "SF37006",
      "price"       : 26.19,
      "map_desc_id" : "SF37006",
      "article_nr"  : "SF-37006",
      "stock"       : 0.0,
      "barcode"     : "086301370066",
      "hash"        : "a5baa563441b54c20a807c695c4f1e6c",
      "map_price_id": "SF37006",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT DMP Copper, C (37.0-38.5)",
        "map_id"   : "SF-37006de",
        "remapid"  : "SF37006",
        "extras"   : {},
        "label"    : "SF-37006",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT DMP Copper",
        "type"     : 0,
        "hash"     : "281ee26da9ce2e66a1c118eaaa6252bc"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : false,
      "map_pic_id"  : "SF-37000",
      "vat"         : 7,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-37008",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-37000",
        "vororder"    : "true",
        "uvp"         : "60.0",
        "groesse"     : "D (39.0-41.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "0.0",
        "Variante"    : "TRIM-TO-FIT DMP Copper"
      },
      "sort"        : "00000",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF37008",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF37008"
        }
      ],
      "map_id"      : "SF37008",
      "price"       : 26.19,
      "map_desc_id" : "SF37008",
      "article_nr"  : "SF-37008",
      "stock"       : 0.0,
      "barcode"     : "086301370080",
      "hash"        : "4defce4f65f3c0a8dece5c99e43decf3",
      "map_price_id": "SF37008",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT DMP Copper, D (39.0-41.0)",
        "map_id"   : "SF-37008de",
        "remapid"  : "SF37008",
        "extras"   : {},
        "label"    : "SF-37008",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT DMP Copper",
        "type"     : 0,
        "hash"     : "51fd15de59f710bbf18a6c8b775f86dc"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : false,
      "map_pic_id"  : "SF-37000",
      "vat"         : 7,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-37010",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-37000",
        "vororder"    : "true",
        "uvp"         : "60.0",
        "groesse"     : "E (42.0-44.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "0.0",
        "Variante"    : "TRIM-TO-FIT DMP Copper"
      },
      "sort"        : "00000",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF37010",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF37010"
        }
      ],
      "map_id"      : "SF37010",
      "price"       : 26.19,
      "map_desc_id" : "SF37010",
      "article_nr"  : "SF-37010",
      "stock"       : 0.0,
      "barcode"     : "086301370103",
      "hash"        : "6834f0961f4dd8e7d121321936cdbbe1",
      "map_price_id": "SF37010",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT DMP Copper, E (42.0-44.0)",
        "map_id"   : "SF-37010de",
        "remapid"  : "SF37010",
        "extras"   : {},
        "label"    : "SF-37010",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT DMP Copper",
        "type"     : 0,
        "hash"     : "c2e7c8ae8197f9561a0b4a6e6f591bbf"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : false,
      "map_pic_id"  : "SF-37000",
      "vat"         : 7,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-37012",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-37000",
        "vororder"    : "true",
        "uvp"         : "60.0",
        "groesse"     : "F (45.0-46.5)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "0.0",
        "Variante"    : "TRIM-TO-FIT DMP Copper"
      },
      "sort"        : "00000",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF37012",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF37012"
        }
      ],
      "map_id"      : "SF37012",
      "price"       : 26.19,
      "map_desc_id" : "SF37012",
      "article_nr"  : "SF-37012",
      "stock"       : 0.0,
      "barcode"     : "086301370127",
      "hash"        : "c1e5cfc7a5b8f8a93b6418af572b05ae",
      "map_price_id": "SF37012",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT DMP Copper, F (45.0-46.5)",
        "map_id"   : "SF-37012de",
        "remapid"  : "SF37012",
        "extras"   : {},
        "label"    : "SF-37012",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT DMP Copper",
        "type"     : 0,
        "hash"     : "eb12cf56a745a6284265c3afc213905d"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : false,
      "map_pic_id"  : "SF-37000",
      "vat"         : 7,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-37014",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-37000",
        "vororder"    : "true",
        "uvp"         : "60.0",
        "groesse"     : "G (47.0-49.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "0.0",
        "Variante"    : "TRIM-TO-FIT DMP Copper"
      },
      "sort"        : "00000",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF37014",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF37014"
        }
      ],
      "map_id"      : "SF37014",
      "price"       : 26.19,
      "map_desc_id" : "SF37014",
      "article_nr"  : "SF-37014",
      "stock"       : 0.0,
      "barcode"     : "086301370141",
      "hash"        : "c2f0625c808b297126fd3ea727f094f4",
      "map_price_id": "SF37014",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT DMP Copper, G (47.0-49.0)",
        "map_id"   : "SF-37014de",
        "remapid"  : "SF37014",
        "extras"   : {},
        "label"    : "SF-37014",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT DMP Copper",
        "type"     : 0,
        "hash"     : "dc610650f1b792ab43b43aecd8e8f5c6"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-6400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-6405",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-6400",
        "vororder"    : "true",
        "uvp"         : "55.0",
        "groesse"     : "B (34.0-36.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "5.0",
        "Variante"    : "TRIM-TO-FIT Berry"
      },
      "sort"        : "00027",
      "type"        : 1,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF6405",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF6405"
        }
      ],
      "map_id"      : "SF6405",
      "price"       : 26.19,
      "map_desc_id" : "SF6405",
      "article_nr"  : "SF-6405",
      "stock"       : 1.0,
      "barcode"     : "086301564052",
      "hash"        : "87349e03d2c5999e878476334ed2951c",
      "map_price_id": "SF6405",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Berry, B (34.0-36.0)",
        "map_id"   : "SF-6405de",
        "remapid"  : "SF6405",
        "extras"   : {},
        "label"    : "SF-6405",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Berry",
        "type"     : 0,
        "hash"     : "19732507a7eec021f90df429607d9a37"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-6400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-6407",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-6400",
        "vororder"    : "true",
        "uvp"         : "55.0",
        "groesse"     : "C (37.0-38.5)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "5.0",
        "Variante"    : "TRIM-TO-FIT Berry"
      },
      "sort"        : "00027",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF6407",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF6407"
        }
      ],
      "map_id"      : "SF6407",
      "price"       : 26.19,
      "map_desc_id" : "SF6407",
      "article_nr"  : "SF-6407",
      "stock"       : 4.0,
      "barcode"     : "086301564076",
      "hash"        : "79f089e377ed6fdec4fd98f0a82cb26e",
      "map_price_id": "SF6407",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Berry, C (37.0-38.5)",
        "map_id"   : "SF-6407de",
        "remapid"  : "SF6407",
        "extras"   : {},
        "label"    : "SF-6407",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Berry",
        "type"     : 0,
        "hash"     : "7ac178943d40812f23369844a299b8eb"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-6400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-6409",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-6400",
        "vororder"    : "true",
        "uvp"         : "55.0",
        "groesse"     : "D (39.0-41.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "5.0",
        "Variante"    : "TRIM-TO-FIT Berry"
      },
      "sort"        : "00027",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF6409",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF6409"
        }
      ],
      "map_id"      : "SF6409",
      "price"       : 26.19,
      "map_desc_id" : "SF6409",
      "article_nr"  : "SF-6409",
      "stock"       : 0.0,
      "barcode"     : "086301564090",
      "hash"        : "fd1ad32f490e6e0c90fe24a1819a154e",
      "map_price_id": "SF6409",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Berry, D (39.0-41.0)",
        "map_id"   : "SF-6409de",
        "remapid"  : "SF6409",
        "extras"   : {},
        "label"    : "SF-6409",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Berry",
        "type"     : 0,
        "hash"     : "25197919a99b0c1c27db3d8faecb65ca"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-6400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-6411",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-6400",
        "vororder"    : "true",
        "uvp"         : "55.0",
        "groesse"     : "E (42.0-44.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "5.0",
        "Variante"    : "TRIM-TO-FIT Berry"
      },
      "sort"        : "00027",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF6411",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF6411"
        }
      ],
      "map_id"      : "SF6411",
      "price"       : 26.19,
      "map_desc_id" : "SF6411",
      "article_nr"  : "SF-6411",
      "stock"       : 0.0,
      "barcode"     : "086301564113",
      "hash"        : "4cd92ec081a2d6f87f9c131bd3164c2e",
      "map_price_id": "SF6411",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Berry, E (42.0-44.0)",
        "map_id"   : "SF-6411de",
        "remapid"  : "SF6411",
        "extras"   : {},
        "label"    : "SF-6411",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Berry",
        "type"     : 0,
        "hash"     : "d74bddf419de1c139e907ac1ea3e73f9"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-71000",
      "vat"         : 7,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-71005",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-71000",
        "vororder"    : "true",
        "uvp"         : "60.0",
        "groesse"     : "B (34.0-36.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "23.0",
        "Variante"    : "TRIM-TO-FIT Hot Pink"
      },
      "sort"        : "00213",
      "type"        : 1,
      "pinfos"      : {
        "brutto": "28.57"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF71005",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF71005"
        }
      ],
      "map_id"      : "SF71005",
      "price"       : 28.57,
      "map_desc_id" : "SF71005",
      "article_nr"  : "SF-71005",
      "stock"       : 7.0,
      "barcode"     : "086301710053",
      "hash"        : "3d9814750597e712b8a7a8e5716b0743",
      "map_price_id": "SF71005",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Hot Pink, B (34.0-36.0)",
        "map_id"   : "SF-71005de",
        "remapid"  : "SF71005",
        "extras"   : {},
        "label"    : "SF-71005",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Hot Pink",
        "type"     : 0,
        "hash"     : "bd57f4431983db8810d2b69b0dad3713"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-71000",
      "vat"         : 7,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-71007",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-71000",
        "vororder"    : "true",
        "uvp"         : "60.0",
        "groesse"     : "C (37.0-38.5)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "23.0",
        "Variante"    : "TRIM-TO-FIT Hot Pink"
      },
      "sort"        : "00213",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "28.57"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF71007",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF71007"
        }
      ],
      "map_id"      : "SF71007",
      "price"       : 28.57,
      "map_desc_id" : "SF71007",
      "article_nr"  : "SF-71007",
      "stock"       : 6.0,
      "barcode"     : "086301710077",
      "hash"        : "c46cac6620318af84060790482d9c49f",
      "map_price_id": "SF71007",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Hot Pink, C (37.0-38.5)",
        "map_id"   : "SF-71007de",
        "remapid"  : "SF71007",
        "extras"   : {},
        "label"    : "SF-71007",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Hot Pink",
        "type"     : 0,
        "hash"     : "b8e7282fd82742f71f7ed9187c56e865"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-71000",
      "vat"         : 7,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-71009",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-71000",
        "vororder"    : "true",
        "uvp"         : "60.0",
        "groesse"     : "D (39.0-41.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "23.0",
        "Variante"    : "TRIM-TO-FIT Hot Pink"
      },
      "sort"        : "00213",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "28.57"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF71009",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF71009"
        }
      ],
      "map_id"      : "SF71009",
      "price"       : 28.57,
      "map_desc_id" : "SF71009",
      "article_nr"  : "SF-71009",
      "stock"       : 6.0,
      "barcode"     : "086301710091",
      "hash"        : "2522b95f768abdaf491c797408fb7b3b",
      "map_price_id": "SF71009",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Hot Pink, D (39.0-41.0)",
        "map_id"   : "SF-71009de",
        "remapid"  : "SF71009",
        "extras"   : {},
        "label"    : "SF-71009",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Hot Pink",
        "type"     : 0,
        "hash"     : "5cf78465571fbc8bb7a326e1ed90630c"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-71000",
      "vat"         : 7,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-71011",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-71000",
        "vororder"    : "true",
        "uvp"         : "60.0",
        "groesse"     : "E (42.0-44.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "23.0",
        "Variante"    : "TRIM-TO-FIT Hot Pink"
      },
      "sort"        : "00213",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "28.57"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF71011",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF71011"
        }
      ],
      "map_id"      : "SF71011",
      "price"       : 28.57,
      "map_desc_id" : "SF71011",
      "article_nr"  : "SF-71011",
      "stock"       : 4.0,
      "barcode"     : "086301710114",
      "hash"        : "fdf206960b4bd90668ac33c6dbf9380e",
      "map_price_id": "SF71011",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Hot Pink, E (42.0-44.0)",
        "map_id"   : "SF-71011de",
        "remapid"  : "SF71011",
        "extras"   : {},
        "label"    : "SF-71011",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Hot Pink",
        "type"     : 0,
        "hash"     : "94028d20a1ba5d9c79d7e5c23e96942d"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-72000",
      "vat"         : 7,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-72006",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-72000",
        "vororder"    : "true",
        "uvp"         : "60.0",
        "groesse"     : "C (37.0-38.5)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "25.0",
        "Variante"    : "TRIM-TO-FIT Red Hot"
      },
      "sort"        : "00207",
      "type"        : 1,
      "pinfos"      : {
        "brutto": "28.57"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF72006",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF72006"
        }
      ],
      "map_id"      : "SF72006",
      "price"       : 28.57,
      "map_desc_id" : "SF72006",
      "article_nr"  : "SF-72006",
      "stock"       : 7.0,
      "barcode"     : "086301720069",
      "hash"        : "b45720529f601a1b12a22389e076f048",
      "map_price_id": "SF72006",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Red Hot, C (37.0-38.5)",
        "map_id"   : "SF-72006de",
        "remapid"  : "SF72006",
        "extras"   : {},
        "label"    : "SF-72006",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Red Hot",
        "type"     : 0,
        "hash"     : "8eb1cbe7a36736d5a340067448b1143b"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-72000",
      "vat"         : 7,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-72008",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-72000",
        "vororder"    : "true",
        "uvp"         : "60.0",
        "groesse"     : "D (39.0-41.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "25.0",
        "Variante"    : "TRIM-TO-FIT Red Hot"
      },
      "sort"        : "00207",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "28.57"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF72008",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF72008"
        }
      ],
      "map_id"      : "SF72008",
      "price"       : 28.57,
      "map_desc_id" : "SF72008",
      "article_nr"  : "SF-72008",
      "stock"       : 6.0,
      "barcode"     : "086301720083",
      "hash"        : "e40a9dc09fbd3ecb9106fd043df67afe",
      "map_price_id": "SF72008",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Red Hot, D (39.0-41.0)",
        "map_id"   : "SF-72008de",
        "remapid"  : "SF72008",
        "extras"   : {},
        "label"    : "SF-72008",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Red Hot",
        "type"     : 0,
        "hash"     : "1777e9cd0199eb1c27cb268386c3a092"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-72000",
      "vat"         : 7,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-72010",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-72000",
        "vororder"    : "true",
        "uvp"         : "60.0",
        "groesse"     : "E (42.0-44.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "25.0",
        "Variante"    : "TRIM-TO-FIT Red Hot"
      },
      "sort"        : "00207",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "28.57"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF72010",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF72010"
        }
      ],
      "map_id"      : "SF72010",
      "price"       : 28.57,
      "map_desc_id" : "SF72010",
      "article_nr"  : "SF-72010",
      "stock"       : 5.0,
      "barcode"     : "086301720106",
      "hash"        : "126f0d69385cb88317441a338a8366fa",
      "map_price_id": "SF72010",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Red Hot, E (42.0-44.0)",
        "map_id"   : "SF-72010de",
        "remapid"  : "SF72010",
        "extras"   : {},
        "label"    : "SF-72010",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Red Hot",
        "type"     : 0,
        "hash"     : "464a3c064b4a83ae08712a84e6e15a57"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-72000",
      "vat"         : 7,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-72012",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-72000",
        "vororder"    : "true",
        "uvp"         : "60.0",
        "groesse"     : "F (45.0-46.5)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "25.0",
        "Variante"    : "TRIM-TO-FIT Red Hot"
      },
      "sort"        : "00207",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "28.57"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF72012",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF72012"
        }
      ],
      "map_id"      : "SF72012",
      "price"       : 28.57,
      "map_desc_id" : "SF72012",
      "article_nr"  : "SF-72012",
      "stock"       : 7.0,
      "barcode"     : "086301720120",
      "hash"        : "a6c90569878d9abb11c0a46f0a9004b9",
      "map_price_id": "SF72012",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Red Hot, F (45.0-46.5)",
        "map_id"   : "SF-72012de",
        "remapid"  : "SF72012",
        "extras"   : {},
        "label"    : "SF-72012",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Red Hot",
        "type"     : 0,
        "hash"     : "f316c1ce45db689cfe0746ddaa899934"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-72000",
      "vat"         : 7,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-72014",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-72000",
        "vororder"    : "true",
        "uvp"         : "60.0",
        "groesse"     : "G (47.0-49.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "25.0",
        "Variante"    : "TRIM-TO-FIT Red Hot"
      },
      "sort"        : "00207",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "28.57"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF72014",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF72014"
        }
      ],
      "map_id"      : "SF72014",
      "price"       : 28.57,
      "map_desc_id" : "SF72014",
      "article_nr"  : "SF-72014",
      "stock"       : 0.0,
      "barcode"     : "086301720144",
      "hash"        : "53bfd0fcbf74e0510c82c094e5c5044e",
      "map_price_id": "SF72014",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Red Hot, G (47.0-49.0)",
        "map_id"   : "SF-72014de",
        "remapid"  : "SF72014",
        "extras"   : {},
        "label"    : "SF-72014",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Red Hot",
        "type"     : 0,
        "hash"     : "5c667ceb1525e4bf4c5f4b4274975318"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-7400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-7406",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-7400",
        "vororder"    : "true",
        "uvp"         : "55.0",
        "groesse"     : "C (37.0-38.5)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "7.0",
        "Variante"    : "TRIM-TO-FIT Orange"
      },
      "sort"        : "00091",
      "type"        : 1,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF7406",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF7406"
        }
      ],
      "map_id"      : "SF7406",
      "price"       : 26.19,
      "map_desc_id" : "SF7406",
      "article_nr"  : "SF-7406",
      "stock"       : 2.0,
      "barcode"     : "086301574068",
      "hash"        : "a086d5e8271421479cbf45a3d57af7b9",
      "map_price_id": "SF7406",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Orange, C (37.0-38.5)",
        "map_id"   : "SF-7406de",
        "remapid"  : "SF7406",
        "extras"   : {},
        "label"    : "SF-7406",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Orange",
        "type"     : 0,
        "hash"     : "31b5220672e50076cbbe74e742044107"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-7400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-7408",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-7400",
        "vororder"    : "true",
        "uvp"         : "55.0",
        "groesse"     : "D (39.0-41.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "7.0",
        "Variante"    : "TRIM-TO-FIT Orange"
      },
      "sort"        : "00091",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF7408",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF7408"
        }
      ],
      "map_id"      : "SF7408",
      "price"       : 26.19,
      "map_desc_id" : "SF7408",
      "article_nr"  : "SF-7408",
      "stock"       : 2.0,
      "barcode"     : "086301574082",
      "hash"        : "d89b7e023fdbf27b36adc53f31c07a23",
      "map_price_id": "SF7408",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Orange, D (39.0-41.0)",
        "map_id"   : "SF-7408de",
        "remapid"  : "SF7408",
        "extras"   : {},
        "label"    : "SF-7408",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Orange",
        "type"     : 0,
        "hash"     : "e87475fd2175077bed2b0df2e3009d84"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-7400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-7410",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-7400",
        "vororder"    : "true",
        "uvp"         : "55.0",
        "groesse"     : "E (42.0-44.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "7.0",
        "Variante"    : "TRIM-TO-FIT Orange"
      },
      "sort"        : "00091",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF7410",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF7410"
        }
      ],
      "map_id"      : "SF7410",
      "price"       : 26.19,
      "map_desc_id" : "SF7410",
      "article_nr"  : "SF-7410",
      "stock"       : 0.0,
      "barcode"     : "086301574105",
      "hash"        : "18b842d65d3db443714027038b987b10",
      "map_price_id": "SF7410",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Orange, E (42.0-44.0)",
        "map_id"   : "SF-7410de",
        "remapid"  : "SF7410",
        "extras"   : {},
        "label"    : "SF-7410",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Orange",
        "type"     : 0,
        "hash"     : "abb1ad4b7d511c9234438eb85199d655"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-7400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-7412",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-7400",
        "vororder"    : "true",
        "uvp"         : "55.0",
        "groesse"     : "F (45.0-46.5)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "7.0",
        "Variante"    : "TRIM-TO-FIT Orange"
      },
      "sort"        : "00091",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF7412",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF7412"
        }
      ],
      "map_id"      : "SF7412",
      "price"       : 26.19,
      "map_desc_id" : "SF7412",
      "article_nr"  : "SF-7412",
      "stock"       : 3.0,
      "barcode"     : "086301574129",
      "hash"        : "61b472f67d9f183810c748ceb0069b42",
      "map_price_id": "SF7412",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Orange, F (45.0-46.5)",
        "map_id"   : "SF-7412de",
        "remapid"  : "SF7412",
        "extras"   : {},
        "label"    : "SF-7412",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Orange",
        "type"     : 0,
        "hash"     : "b93c5a1039016e0824ce3c1692fae873"
      }
    },
    {
      "mainart"     : "SF1402",
      "images"      : [
        1
      ],
      "created"     : "1970-01-01",
      "baseunit"    : "stk",
      "reordered"   : true,
      "map_pic_id"  : "SF-7400",
      "vat"         : 19,
      "quantities"  : [
        {
          "des"        : "Paar",
          "map_desc_id": "Paar",
          "multi"      : 1.0
        }
      ],
      "flags"       : {
        "ihand": true,
        "bshop": true,
        "ifair": true
      },
      "extras"      : {
        "hersteller"  : "Superfeet",
        "winline_art" : "SF-7414",
        "sofortorder" : "true",
        "orderable"   : "true",
        "verfuegbarab": "null",
        "stamm_art"   : "SF-7400",
        "vororder"    : "true",
        "uvp"         : "55.0",
        "groesse"     : "G (47.0-49.0)",
        "sale"        : "false",
        "cat_id"      : "00048-00002-00000-00000-00000",
        "salerabatt"  : "null",
        "varbestand"  : "7.0",
        "Variante"    : "TRIM-TO-FIT Orange"
      },
      "sort"        : "00091",
      "type"        : 0,
      "pinfos"      : {
        "brutto": "26.19"
      },
      "tags"        : [],
      "cats"        : [
        {
          "article_id": "SF7414",
          "cat_id"    : "00048-00002-00000-00000-00000",
          "sort"      : "SF7414"
        }
      ],
      "map_id"      : "SF7414",
      "price"       : 26.19,
      "map_desc_id" : "SF7414",
      "article_nr"  : "SF-7414",
      "stock"       : 0.0,
      "barcode"     : "086301574143",
      "hash"        : "1fcaa7a87b2cf7d3a69bb8ca845667ed",
      "map_price_id": "SF7414",
      "desc"        : {
        "search"   : "Superfeet",
        "des"      : "Superfeet, TRIM-TO-FIT Orange, G (47.0-49.0)",
        "map_id"   : "SF-7414de",
        "remapid"  : "SF7414",
        "extras"   : {},
        "label"    : "SF-7414",
        "lang"     : "de",
        "short_des": "Superfeet, TRIM-TO-FIT Orange",
        "type"     : 0,
        "hash"     : "47d41b9ef9be0e946e93351b37ed594f"
      }
    }
  ],
  "size"  : 125
}


const reportStore = new ReportStoreStore()
window[ "reportStore" ] = reportStore
export default reportStore



// WEBPACK FOOTER //
// ./src/stores/reportStore.js